/* ============================================================
   Gallery wall visualizer — TOON atelier
   Zie docs/gallery-wall-plan.md

   Lijsten en passe-partouts zijn losse dingen op de muur. Schuif je
   ze over elkaar en hebben ze dezelfde buitenmaat, dan worden ze één
   geheel — precies zoals het in het echt ook gaat.

   De muurfoto blijft in de browser: verkleind, in localStorage,
   nooit naar een server.
   ============================================================ */

(function () {
  'use strict';

  var OPSLAG = 'toon-gallery-wall-v3';
  var PROFIEL_CM = 0.9;       // de echte rand van elke wissellijst: 9 mm
  // Op ware grootte is die rand op een muur van twee meter maar drie pixels
  // breed, en dan verdwijnt een lichte lijst tegen een lichte muur. Daarom
  // tekenen we hem een tikje dikker dan hij is, met een ondergrens in pixels
  // voor wie een hele kamerwand inlaadt. Het uitsnijden van de productfoto
  // blijft op de echte 9 mm: daar gaat het om wat er op de foto staat.
  var PROFIEL_TEKEN_CM = 1.15;
  var PROFIEL_MIN_PX = 2.6;
  var BRON_FORMAAT_CM = 30;   // de productfoto's tonen een lijst van 30x40
  var STAAL_CM = 7;           // een kleurstaaltje is ongeveer 7 cm breed
  var MAX_FOTO_PX = 1800;
  var MAX_BESTAND = 25 * 1024 * 1024;
  var SNAP_CM = 1.2;
  var TEXTUUR_VERGROTING = 1.6; // structuur iets groter dan echt, anders zie je niets
  var MAX_GATFOTO_PX = 640;
  var MAX_STAPPEN = 40;          // hoe ver Stap terug teruggaat

  function T(el) {
    var en = el.dataset.lang === 'en';
    if (el.dataset.lang === 'de') return {
      verwijder: 'Entfernen',
      dupliceer: 'Duplizieren',
      losmaken: 'Trennen',
      losmakenMuur: 'Passepartout aus dem Rahmen nehmen',
      stapTerug: 'Rückgängig',
      lijstKleur: 'Rahmenfarbe',
      ppKleur: 'Passepartout-Farbe',
      stripMaat: 'Fotostreifen',
      binnenformaat: 'Innenformat',
      draaien: 'Drehen',
      eenDing: '1 Stück',
      aantalDing: '{n} Stück',
      uitverkocht: 'ausverkauft',
      geenVariant: 'nicht lieferbar',
      cartGelukt: 'In deinen Warenkorb gelegt',
      cartFout: 'Das hat nicht geklappt',
      cartWand: 'Wandgestaltung',
      cartPlek: 'Stück {n}',
      cartUitsnede: 'Ausschnitt',
      samen: 'Ineinandergeschoben',
      paster: 'Das passt nicht in diesen Rahmen',
      leegKaart: 'Nichts gefunden',
      zonderLijst: 'ohne Rahmen',
      zonderPp: 'ohne Passepartout',
      fotoKies: 'Setz dein eigenes Foto in diesen Ausschnitt (nur zum Ansehen, es wird nicht mitbestellt)',
      fotoWeg: 'Fotos entfernen',
      terugVoorbeeld: 'Zurück zur Beispielwand',
      terugEigen: 'Zurück zu deinem eigenen Foto'
    };
    return {
      verwijder:   en ? 'Remove'                    : 'Verwijderen',
      dupliceer:   en ? 'Duplicate'                 : 'Dupliceren',
      losmaken:    en ? 'Take apart'                : 'Losmaken',
      losmakenMuur: en ? 'Take the passe-partout out of the frame' : 'Passe-partout uit de lijst halen',
      stapTerug:   en ? 'Undo'                      : 'Stap terug',
      lijstKleur:  en ? 'Frame colour'              : 'Kleur lijst',
      ppKleur:     en ? 'Passe-partout colour'      : 'Kleur passe-partout',
      stripMaat:   en ? 'Photo strip'               : 'Fotostrip',
      binnenformaat: en ? 'Inner size'              : 'Binnenformaat',
      draaien:     en ? 'Rotate'                    : 'Draaien',
      eenDing:     en ? '1 item'                    : '1 stuk',
      aantalDing:  en ? '{n} items'                 : '{n} stuks',
      uitverkocht: en ? 'sold out'                  : 'uitverkocht',
      geenVariant: en ? 'not available'             : 'niet leverbaar',
      cartGelukt:  en ? 'Added to your cart'        : 'In je winkelwagen gelegd',
      cartFout:    en ? 'That did not work'         : 'Dat lukte niet',
      cartWand:    en ? 'Gallery wall'              : 'Wandontwerp',
      cartPlek:    en ? 'item {n}'                  : 'stuk {n}',
      cartUitsnede: en ? 'Opening'                  : 'Uitsnede',
      samen:       en ? 'Slotted together'          : 'In elkaar geschoven',
      paster:      en ? 'That one does not fit in this frame' : 'Die past niet in deze lijst',
      leegKaart:   en ? 'Nothing found'             : 'Niets gevonden',
      zonderLijst: en ? 'without frame'             : 'zonder lijst',
      zonderPp:    en ? 'without passe-partout'     : 'zonder passe-partout',
      fotoKies:    en ? 'Put your own photo in this opening (just to look at — it is not ordered)'
                      : 'Zet je eigen foto in deze uitsnede (alleen om te kijken, hij wordt niet meebesteld)',
      fotoWeg:     en ? 'Remove the photos'           : 'Foto\'s weghalen',
      terugVoorbeeld: en ? 'Back to the sample wall'  : 'Terug naar de voorbeeldmuur',
      terugEigen:     en ? 'Back to your own photo'   : 'Terug naar je eigen foto'
    };
  }

  /* ---------- materiaal uit de productfoto's ---------- */

  var materiaalCache = {};

  function laadAfbeelding(url) {
    return new Promise(function (res, rej) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { res(img); };
      img.onerror = function () { rej(new Error(url)); };
      img.src = url;
    });
  }

  // Snijdt het onderwerp los van de egale achtergrond van de productfoto.
  //
  // Twee stappen, en de tweede is er niet voor niets: de satijn matte zilveren
  // lijst scheelt maar dertien punten met de achtergrond (247,246,240 tegen
  // 251,253,244). Met de grove drempel viel die rand buiten de boot en werd het
  // blauwe passe-partout uit de productfoto het profiel — de lijst kwam blauw
  // op de muur te staan. Daarom groeit de rand daarna nog uit met een veel
  // lagere drempel, zolang meer dan de helft van de rij of kolom afwijkt. Een
  // zachte slagschaduw haalt dat niet, een echte lijstrand wel.
  function snijUit(img, drempel) {
    var c = document.createElement('canvas');
    var s = Math.min(1, 900 / img.naturalWidth);
    c.width = Math.round(img.naturalWidth * s);
    c.height = Math.round(img.naturalHeight * s);
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, c.width, c.height);
    var d = ctx.getImageData(0, 0, c.width, c.height).data;
    var br = d[0], bg = d[1], bb = d[2];
    function afwijkt(i, dr) {
      return Math.abs(d[i] - br) + Math.abs(d[i + 1] - bg) + Math.abs(d[i + 2] - bb) > dr;
    }
    var x0 = c.width, x1 = 0, y0 = c.height, y1 = 0, x, y, n;
    var minKol = Math.max(3, Math.round(c.height * 0.02));
    var minRij = Math.max(3, Math.round(c.width * 0.02));
    for (x = 0; x < c.width; x++) {
      n = 0;
      for (y = 0; y < c.height; y++) if (afwijkt((y * c.width + x) * 4, drempel)) n++;
      if (n > minKol) { if (x < x0) x0 = x; if (x > x1) x1 = x; }
    }
    for (y = 0; y < c.height; y++) {
      n = 0;
      for (x = 0; x < c.width; x++) if (afwijkt((y * c.width + x) * 4, drempel)) n++;
      if (n > minRij) { if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 <= x0 || y1 <= y0) return null;

    var LICHT = 9, DEEL = 0.55;
    var groeiX = Math.round(c.width * 0.06), groeiY = Math.round(c.height * 0.06);
    function kolomVol(kx) {
      var t = 0, ky;
      for (ky = y0; ky <= y1; ky++) if (afwijkt((ky * c.width + kx) * 4, LICHT)) t++;
      return t > (y1 - y0 + 1) * DEEL;
    }
    function rijVol(ky) {
      var t = 0, kx;
      for (kx = x0; kx <= x1; kx++) if (afwijkt((ky * c.width + kx) * 4, LICHT)) t++;
      return t > (x1 - x0 + 1) * DEEL;
    }
    var gx0 = x0, gx1 = x1, gy0 = y0, gy1 = y1;
    while (gx0 > 0 && x0 - gx0 < groeiX && kolomVol(gx0 - 1)) gx0--;
    while (gx1 < c.width - 1 && gx1 - x1 < groeiX && kolomVol(gx1 + 1)) gx1++;
    while (gy0 > 0 && y0 - gy0 < groeiY && rijVol(gy0 - 1)) gy0--;
    while (gy1 < c.height - 1 && gy1 - y1 < groeiY && rijVol(gy1 + 1)) gy1++;

    var o = document.createElement('canvas');
    o.width = gx1 - gx0 + 1;
    o.height = gy1 - gy0 + 1;
    o.getContext('2d').drawImage(c, gx0, gy0, o.width, o.height, 0, 0, o.width, o.height);
    return { canvas: o, w: o.width, h: o.height };
  }

  // Satijn mat zilver is op de foto bijna wit. Uitgesneden ziet dat er niet uit
  // als aluminium maar als een witte lijst, dus halen we de kleurzweem eruit en
  // leggen we het grijs waar geborsteld aluminium hoort te zitten. De structuur
  // van de foto blijft: daar komt de matte glans vandaan.
  function matZilver(c, band) {
    var ctx = c.getContext('2d', { willReadFrequently: true });
    var im = ctx.getImageData(0, 0, c.width, c.height), d = im.data;
    var x, y, i, lum, som = 0, n = 0;
    // alleen de buitenrand telt mee: dat is het stuk dat straks de lijst wordt
    for (y = 0; y < c.height; y++) {
      for (x = 0; x < c.width; x++) {
        if (x >= band && x < c.width - band && y >= band && y < c.height - band) continue;
        i = (y * c.width + x) * 4;
        som += 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
        n++;
      }
    }
    if (!n) return;
    var gem = som / n;
    for (i = 0; i < d.length; i += 4) {
      lum = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
      var v = Math.max(70, Math.min(248, 198 + (lum - gem) * 0.85));
      d[i] = Math.round(v + 3);
      d[i + 1] = Math.round(v + 1);
      d[i + 2] = Math.round(v - 4);
    }
    ctx.putImageData(im, 0, 0);
  }

  // De gelakte aluminium lijsten — bordeaux, olijfgroen, cherry cola — staan op
  // de productfoto volkomen vlak: over de hele breedte van het profiel precies
  // dezelfde kleur, want de studio belicht ze egaal. In het echt vangt de bolle
  // buitenkant het licht. Dat leggen we er hier op: een lichte band vlak langs
  // de buitenrand en een zweem schaduw aan de binnenkant.
  //
  // Het gaat op afstand tot de buitenrand, niet op een richting. Zo krijgen alle
  // vier de zijden en de hoeken vanzelf hetzelfde verloop, en dat overleeft het
  // uitrekken door border-image: die rekt alleen in de lengte van elke zijde.
  function glans(c, band, sterkte) {
    if (band < 3) return;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    var im = ctx.getImageData(0, 0, c.width, c.height), d = im.data;
    var licht = new Float32Array(band), schaduw = new Float32Array(band), i;
    for (i = 0; i < band; i++) {
      var t = i / band;
      licht[i] = Math.exp(-Math.pow((t - 0.22) / 0.2, 2)) * sterkte;
      schaduw[i] = Math.max(0, (t - 0.7) / 0.3) * sterkte * 0.5;
    }
    var x, y, k, rand;
    for (y = 0; y < c.height; y++) {
      for (x = 0; x < c.width; x++) {
        rand = Math.min(x, y, c.width - 1 - x, c.height - 1 - y);
        if (rand >= band) continue;
        i = (y * c.width + x) * 4;
        for (k = 0; k < 3; k++) {
          var v = d[i + k];
          v = v + (255 - v) * licht[rand];
          v = v * (1 - schaduw[rand]);
          d[i + k] = Math.max(0, Math.min(255, Math.round(v)));
        }
      }
    }
    ctx.putImageData(im, 0, 0);
  }

  // Haalt kleur en structuur uit elkaar zodat het karton naadloos herhaalt.
  //
  // De structuur komt op ware grootte uit het kleurstaaltje (dat is ongeveer
  // 7 cm breed), niet uitgerekt: daardoor is de weving van linnen even fijn als
  // in het echt. Het laagfrequente deel gaat eruit — dat is het licht van de
  // fotostudio, en juist dat gaf die wolkerige vlekken die je in elke tegel
  // terugzag.
  //
  // Daarna wordt de tegel teruggebracht tot precies zoveel pixels als hij op het
  // scherm groot is. Dat is niet om geheugen te sparen: liet je de browser een
  // tegel van 336 pixels op 36 pixels tekenen, dan ging de weving moiréen, en
  // dat kwam als een ruitpatroon over het hele passe-partout terug.
  function maakKarton(img, ppc) {
    var W = img.naturalWidth, H = img.naturalHeight;
    var N = Math.max(48, Math.min(168, Math.floor(Math.min(W, H) * 0.45)));
    var sx = Math.round((W - N) / 2), sy = Math.round((H - N) / 2);
    var c = document.createElement('canvas');
    c.width = N; c.height = N;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, sx, sy, N, N, 0, 0, N, N);
    var im = ctx.getImageData(0, 0, N, N), d = im.data, i;

    var r = 0, g = 0, b = 0, n = 0;
    for (i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 200) continue;
      r += d[i]; g += d[i + 1]; b += d[i + 2]; n++;
    }
    if (!n) return null;
    r = Math.round(r / n); g = Math.round(g / n); b = Math.round(b / n);

    var lum = new Float32Array(N * N);
    for (i = 0; i < N * N; i++) {
      lum[i] = 0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2];
    }
    var laag = vervaag(vervaag(lum, N, 6), N, 6);
    for (i = 0; i < N * N; i++) {
      var v = Math.max(0, Math.min(255, Math.round(128 + (lum[i] - laag[i]) * 1.8)));
      d[i * 4] = d[i * 4 + 1] = d[i * 4 + 2] = v;
      d[i * 4 + 3] = 255;
    }
    ctx.putImageData(im, 0, 0);

    // het kaartje beslaat bijna de hele staalfoto, dus zo breed is die in het echt
    var pxPerCm = (W * 0.94) / STAAL_CM;
    var cm = (N / pxPerCm) * TEXTUUR_VERGROTING;
    var schermPx = Math.round(cm * (ppc || 4) * (window.devicePixelRatio || 1));
    var tegel = naadloos(verklein(c, Math.max(24, Math.min(N, schermPx))));
    return { kleur: 'rgb(' + r + ',' + g + ',' + b + ')', tex: tegel.toDataURL('image/png'), cm: cm };
  }

  // Stapsgewijs halveren middelt netjes uit; in één keer verkleinen laat de
  // browser pixels overslaan en dan krijg je juist die moiré terug.
  function verklein(c, doel) {
    var bron = c;
    while (bron.width / 2 > doel) {
      var h = document.createElement('canvas');
      h.width = Math.round(bron.width / 2);
      h.height = Math.round(bron.height / 2);
      h.getContext('2d').drawImage(bron, 0, 0, h.width, h.height);
      bron = h;
    }
    if (bron.width === doel) return bron;
    var uit = document.createElement('canvas');
    uit.width = doel; uit.height = doel;
    uit.getContext('2d').drawImage(bron, 0, 0, doel, doel);
    return uit;
  }

  // Naadloos maken zonder te spiegelen. Spiegelen sluit wel netjes aan, maar
  // legt een symmetrie over de tegel en dat las je op de muur als een ruitjes-
  // patroon. Daarom wisselen we de vier kwadranten om — de naden verhuizen
  // daarmee van de rand naar het midden — en dekken we dat kruis in het midden
  // af met een strook uit het origineel, die naar de zijkanten uitvloeit.
  function naadloos(c) {
    var N = c.width, h = Math.round(N / 2);
    var t = document.createElement('canvas');
    t.width = N; t.height = N;
    var g = t.getContext('2d');
    g.drawImage(c, h, h, N - h, N - h, 0, 0, N - h, N - h);
    g.drawImage(c, 0, h, h, N - h, N - h, 0, h, N - h);
    g.drawImage(c, h, 0, N - h, h, 0, N - h, N - h, h);
    g.drawImage(c, 0, 0, h, h, N - h, N - h, h, h);

    var band = Math.max(6, Math.round(N * 0.22));
    function strook(staand) {
      var breed = staand ? band * 2 : N;
      var hoog = staand ? N : band * 2;
      var s = document.createElement('canvas');
      s.width = breed; s.height = hoog;
      var sg = s.getContext('2d');
      if (staand) sg.drawImage(c, h - band, 0, band * 2, N, 0, 0, band * 2, N);
      else sg.drawImage(c, 0, h - band, N, band * 2, 0, 0, N, band * 2);
      sg.globalCompositeOperation = 'destination-in';
      var kleurloop = staand ? sg.createLinearGradient(0, 0, breed, 0)
                             : sg.createLinearGradient(0, 0, 0, hoog);
      kleurloop.addColorStop(0, 'rgba(0,0,0,0)');
      kleurloop.addColorStop(0.5, 'rgba(0,0,0,1)');
      kleurloop.addColorStop(1, 'rgba(0,0,0,0)');
      sg.fillStyle = kleurloop;
      sg.fillRect(0, 0, breed, hoog);
      return s;
    }
    g.drawImage(strook(true), N - h - band, 0);
    g.drawImage(strook(false), 0, N - h - band);
    return t;
  }

  // Onscherp maken in twee richtingen; twee keer achter elkaar is dicht genoeg
  // bij een echte gaussiaanse vervaging en een stuk sneller.
  function vervaag(bron, N, straal) {
    var tus = new Float32Array(N * N), uit = new Float32Array(N * N);
    var x, y, k, som, aantal, p;
    for (y = 0; y < N; y++) {
      for (x = 0; x < N; x++) {
        som = 0; aantal = 0;
        for (k = -straal; k <= straal; k++) {
          p = x + k;
          if (p < 0 || p >= N) continue;
          som += bron[y * N + p]; aantal++;
        }
        tus[y * N + x] = som / aantal;
      }
    }
    for (y = 0; y < N; y++) {
      for (x = 0; x < N; x++) {
        som = 0; aantal = 0;
        for (k = -straal; k <= straal; k++) {
          p = y + k;
          if (p < 0 || p >= N) continue;
          som += tus[p * N + x]; aantal++;
        }
        uit[y * N + x] = som / aantal;
      }
    }
    return uit;
  }

  function profiel(url, afwerking) {
    if (!url) return Promise.resolve(null);
    var sleutel = url + '|' + (afwerking || '');
    if (materiaalCache[sleutel]) return materiaalCache[sleutel];
    materiaalCache[sleutel] = laadAfbeelding(url).then(function (img) {
      var c = snijUit(img, 175);
      if (!c) return null;
      var band = Math.max(1, Math.round(c.w * PROFIEL_CM / BRON_FORMAAT_CM));
      if (afwerking === 'zilver') { matZilver(c.canvas, band); glans(c.canvas, band, 0.14); }
      else if (afwerking === 'gelakt') glans(c.canvas, band, 0.26);
      return { url: c.canvas.toDataURL('image/png'), w: c.w, h: c.h, slice: band };
    }).catch(function () { return null; });
    return materiaalCache[sleutel];
  }

  // Waar is deze lijst van gemaakt? Niet op "aluminium" zoeken: dat staat in de
  // naam van alle wissellijsten, ook die met fineer.
  function afwerkingVan(lijst) {
    if (!lijst) return '';
    var naam = String(lijst.kleur || lijst.naam || '') + ' ' + String(lijst.kleur ? '' : lijst.handle || '');
    if (/zilver|silver/i.test(naam)) return 'zilver';
    if (/fineer|eiken|wenge|weng\u00e9|oak/i.test(naam)) return '';
    if (/bordeaux|olijf|groen|green|rood|red|cherry/i.test(naam)) return 'gelakt';
    return '';
  }

  // De stalen plaat van een RVS-lijst, uit de productfoto. Het venster zit daar
  // al in, met een foto erachter, en het venster op de muur kan een andere maat
  // hebben (de fotostrip-lijst heeft er twee). Daarom wordt het gat dichtgezet:
  // het staal is in de lengte geborsteld, dus kolommen van links en rechts
  // ernaast, gespiegeld, sluiten naadloos aan. Daarna tekenen we het venster
  // zelf, op de maat van de gekozen variant.
  // De plaat zelf, zonder de slagschaduw van de fotostudio. Gemeten op de
  // productfoto's: achtergrond rond 250, schaduw rond 220, en de plaat heeft
  // een donker randje rond 150. Vanaf buiten naar binnen is de eerste rij of
  // kolom die gemiddeld onder de 205 komt dus de rand van het staal. Gemeten
  // over het middelste vijfde van het beeld, want daar zit de plaat altijd.
  function plaatUit(img) {
    var c = document.createElement('canvas');
    var s = Math.min(1, 900 / img.naturalWidth);
    c.width = Math.round(img.naturalWidth * s);
    c.height = Math.round(img.naturalHeight * s);
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, c.width, c.height);
    var W = c.width, H = c.height, d = ctx.getImageData(0, 0, W, H).data;
    function lum(x, y) {
      var i = (y * W + x) * 4;
      return (d[i] + d[i + 1] + d[i + 2]) / 3;
    }
    function kolom(x) {
      var t = 0, n = 0;
      for (var y = Math.round(H * 0.4); y < H * 0.6; y++) { t += lum(x, y); n++; }
      return t / n;
    }
    function rij(y) {
      var t = 0, n = 0;
      for (var x = Math.round(W * 0.4); x < W * 0.6; x++) { t += lum(x, y); n++; }
      return t / n;
    }
    var GRENS = 205;
    var x0 = 0, x1 = W - 1, y0 = 0, y1 = H - 1;
    while (x0 < W / 2 && kolom(x0) > GRENS) x0++;
    while (x1 > W / 2 && kolom(x1) > GRENS) x1--;
    while (y0 < H / 2 && rij(y0) > GRENS) y0++;
    while (y1 > H / 2 && rij(y1) > GRENS) y1--;
    // het randje zelf hoort er niet bij
    x0 += 2; y0 += 2; x1 -= 2; y1 -= 2;
    if (x1 - x0 < 20 || y1 - y0 < 20) return null;
    var o = document.createElement('canvas');
    o.width = x1 - x0 + 1;
    o.height = y1 - y0 + 1;
    o.getContext('2d').drawImage(c, x0, y0, o.width, o.height, 0, 0, o.width, o.height);
    return o;
  }

  function maakStaal(img, spec, liggend) {
    var plaat = plaatUit(img);
    if (!plaat) return null;
    var pw = plaat.width, ph = plaat.height;

    var vw = 0, vh = 0;
    Object.keys(spec.vensters).forEach(function (k) {
      vw = Math.max(vw, spec.vensters[k][0]);
      vh = Math.max(vh, spec.vensters[k][1]);
    });
    // speling rondom: op de foto steekt de polaroid iets uit
    var gw = Math.ceil((vw + 1.6) * pw / spec.buiten[0]);
    var gh = Math.ceil((vh + 2.4) * ph / spec.buiten[1]);
    var gx0 = Math.round((pw - gw) / 2), gy0 = Math.round((ph - gh) / 2);
    var ctx = plaat.getContext('2d', { willReadFrequently: true });
    // Elke kolom in het gat krijgt een gespiegelde kolom van links of rechts
    // ernaast. Geborsteld staal streept per kolom lichter of donkerder, dus
    // daarna wordt elke kolom zo verschoven dat hij boven en onder precies
    // aansluit op het staal dat er op die plek al zat (daartussen geleidelijk).
    gx0 = Math.max(1, gx0); gy0 = Math.max(6, gy0);
    gw = Math.min(gw, pw - 2 * gx0); gh = Math.min(gh, ph - 2 * gy0);
    var im = ctx.getImageData(0, 0, pw, ph), d = im.data;
    var org = new Uint8ClampedArray(d);
    var B = 6, half = Math.ceil(gw / 2);
    function gem(x, y0b, c) {
      var t = 0;
      for (var y = y0b; y < y0b + B; y++) t += org[(y * pw + x) * 4 + c];
      return t / B;
    }
    for (var x = gx0; x < gx0 + gw; x++) {
      var i = x - gx0;
      var xs = i < half ? gx0 - 1 - i : gx0 + gw + (gw - 1 - i);
      xs = Math.max(0, Math.min(pw - 1, xs));
      for (var c = 0; c < 3; c++) {
        var boven = gem(x, gy0 - B, c) - gem(xs, gy0 - B, c);
        var onder = gem(x, gy0 + gh, c) - gem(xs, gy0 + gh, c);
        for (var y = gy0; y < gy0 + gh; y++) {
          var t = (y - gy0) / (gh - 1);
          d[(y * pw + x) * 4 + c] = org[(y * pw + xs) * 4 + c] + boven + (onder - boven) * t;
        }
      }
    }
    ctx.putImageData(im, 0, 0);

    var uit = document.createElement('canvas');
    var c2 = uit.getContext('2d');
    if (liggend) {
      uit.width = ph;
      uit.height = pw;
      c2.translate(ph, 0);
      c2.rotate(Math.PI / 2);
    } else {
      uit.width = pw;
      uit.height = ph;
    }
    c2.drawImage(plaat, 0, 0);
    return uit.toDataURL('image/jpeg', 0.88);
  }

  function staal(url, handle, liggend) {
    var U = window.GalleryWallUitsneden;
    var spec = U && U.rvs(handle);
    if (!url || !spec) return Promise.resolve(null);
    var sleutel = 'staal|' + url + '|' + (liggend ? 1 : 0);
    if (materiaalCache[sleutel]) return materiaalCache[sleutel];
    materiaalCache[sleutel] = laadAfbeelding(url).then(function (img) {
      return maakStaal(img, spec, liggend);
    }).catch(function () { return null; });
    return materiaalCache[sleutel];
  }

  // De tegel hangt van de schaal af, dus die zit in de sleutel. Afgerond op een
  // halve pixel per centimeter: anders maken we bij elke muisbeweging een nieuwe.
  function karton(url, ppc) {
    if (!url) return Promise.resolve(null);
    var schaal = Math.max(0.5, Math.round((ppc || 4) * 2) / 2);
    var sleutel = url + '|' + schaal;
    if (materiaalCache[sleutel]) return materiaalCache[sleutel];
    materiaalCache[sleutel] = laadAfbeelding(url).then(function (img) {
      return maakKarton(img, schaal);
    }).catch(function () { return null; });
    return materiaalCache[sleutel];
  }

  /* ---------- maten uit variantnamen ---------- */

  // "40x50 cm" -> {w:40,h:50} · "A4 / 21x29,7 cm" -> {w:21,h:29.7}
  function leesFormaat(tekst) {
    if (!tekst) return null;
    var m = String(tekst).match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    if (!m) return null;
    var w = parseFloat(m[1].replace(',', '.'));
    var h = parseFloat(m[2].replace(',', '.'));
    if (!w || !h) return null;
    return { w: w, h: h };
  }

  // Het stuk van een varianttitel waar de maat in staat.
  //
  // De volgorde van de opties ligt niet vast. Bij de meeste passe-partouts staat
  // het formaat voorop ("A4 / 21x29,7 cm / Canvas Cream"), maar bij Balans staat
  // de kleur er juist voor ("Hold My Olive - Green / A4 / 21x29,7 cm"), en bij
  // de wissellijsten staat hij erachter ("30x40 cm / Rioja Red - Bordeaux").
  // Daarom zoeken we het deel op waar echt een maat in staat, en plakken we er
  // alleen het papierformaat voor als dat er los voor staat.
  function maatDeel(titel) {
    var delen = String(titel || '').split('/').map(function (d) { return d.trim(); });
    for (var i = 0; i < delen.length; i++) {
      if (leesFormaat(delen[i])) {
        if (i > 0 && /^[a-z]\d$/i.test(delen[i - 1])) return delen[i - 1] + ' / ' + delen[i];
        return delen[i];
      }
    }
    return null;
  }

  // Een varianttitel zonder de binnenformaten. Bij de fotostrips staat de maat
  // van de strip ("5x15 cm", "4x20 cm") als optie in de titel, en die werd
  // anders voor het buitenformaat aangezien.
  function zonderBinnen(titel, binnen) {
    if (!binnen || !binnen.length) return String(titel || '');
    var weg = binnen.map(function (b) { return String(b).toLowerCase().trim(); });
    return String(titel || '').split('/').filter(function (d) {
      return weg.indexOf(d.trim().toLowerCase()) === -1;
    }).join('/');
  }

  // De variant zoeken bij een formaat, een kleur en eventueel een binnenformaat.
  //
  // Op de maat wordt gerékend en niet gezocht. Op /en/ zijn de varianttitels
  // vertaald en schrijft de winkel "21x29.7" met een punt waar het Nederlands
  // "21x29,7" met een komma heeft; zoeken op tekst vond daar niets, en dan stond
  // er "niet leverbaar" bij een passe-partout die gewoon op voorraad ligt. Kleur
  // en binnenformaat blijven wel tekst — dat zijn namen, geen getallen.
  function zoekVariant(varianten, delen, maat, binnen) {
    var schoon = delen.filter(function (d) { return d; })
      .map(function (d) { return String(d).toLowerCase().trim(); });
    var kandidaten = (varianten || []).filter(function (v) {
      var t = String(v.titel).toLowerCase();
      if (!schoon.every(function (d) { return t.indexOf(d) !== -1; })) return false;
      if (maat) {
        var zb = zonderBinnen(v.titel, binnen);
        var m = leesFormaat(maatDeel(zb)) || leesFormaat(zb);
        if (!m) return false;
        if (Math.abs(m.w - maat.w) > 0.6 || Math.abs(m.h - maat.h) > 0.6) return false;
      }
      return true;
    });
    if (!kandidaten.length) return null;
    var beschikbaar = kandidaten.filter(function (v) { return v.beschikbaar; });
    return beschikbaar.length ? beschikbaar[0] : kandidaten[0];
  }

  // Is deze kartonkleur licht genoeg om er donker op te zetten? Zonder kleur
  // (een lege lijst) telt het vlak als licht.
  function isLicht(hex) {
    if (!hex) return true;
    var m = String(hex).replace('#', '');
    if (m.length === 3) m = m[0] + m[0] + m[1] + m[1] + m[2] + m[2];
    if (m.length !== 6) return true;
    var r = parseInt(m.slice(0, 2), 16),
        g = parseInt(m.slice(2, 4), 16),
        b = parseInt(m.slice(4, 6), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) > 150;
  }

  // Het prijsformaat komt uit de winkelinstellingen, zodat bedragen er
  // hetzelfde uitzien als op de rest van de site.
  var geldFormaat = '€{{amount_with_comma_separator}}';

  function euro(centen) {
    if (centen === null || centen === undefined) return '';
    var bedrag = centen / 100;
    return geldFormaat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, soort) {
      var komma = soort.indexOf('comma_separator') !== -1;
      var heelGetal = soort.indexOf('no_decimals') !== -1;
      var n = heelGetal ? String(Math.round(bedrag)) : bedrag.toFixed(2);
      var delen = n.split('.');
      var heel = delen[0].replace(/\B(?=(\d{3})+(?!\d))/g, komma ? '.' : ',');
      return delen[1] ? heel + (komma ? ',' : '.') + delen[1] : heel;
    });
  }

  // Houdt rekening met /en/ en andere taalpaden.
  function cartPad(pad) {
    var wortel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return (wortel + pad.replace(/^\//, '')).replace(/\/{2,}/g, '/');
  }

  /* ---------- het element ---------- */

  function GalleryWall() { return Reflect.construct(HTMLElement, [], GalleryWall); }
  GalleryWall.prototype = Object.create(HTMLElement.prototype);
  GalleryWall.prototype.constructor = GalleryWall;
  Object.setPrototypeOf(GalleryWall, HTMLElement);

  GalleryWall.prototype.connectedCallback = function () {
    var el = this;
    this.t = T(this);
    if (this.dataset.moneyFormat) geldFormaat = this.dataset.moneyFormat;
    this.lijsten = this.leesJSON('[data-gw-frames]') || [];
    // De RVS-lijsten staan in dezelfde rij, achter de wissellijsten.
    var rvs = this.leesJSON('[data-gw-rvs]') || [];
    rvs.forEach(function (p) { p.rvs = true; });
    this.lijsten = this.lijsten.concat(rvs);
    this.ppProducten = this.leesJSON('[data-gw-designs]') || [];
    this.kleuren = this.leesJSON('[data-gw-mats]') || [];
    this.groepen = this.leesJSON('[data-gw-mat-groups]') || [];
    this.groep = '';
    // anders: de foto waar je vandaan komt, met alles wat daarop stond. Zo
    // kost heen en weer kijken tussen de voorbeeldmuur en je eigen foto geen
    // ontwerp.
    this.state = { foto: null, ar: 1, ijk: null, fotoCm: null, items: [], gekozen: null, anders: null };
    // Eerdere standen van de muur, voor de knop Stap terug. Alleen de stukken,
    // niet de foto of de maat: die hebben hun eigen knoppen. Leeft zolang de
    // pagina openstaat en gaat niet mee in de opslag.
    this.geschiedenis = [];

    this.vind();
    this.knoppen();
    this.tekenKaarten();
    this.tekenGroepen();
    this.voorbeeldSrc = (this.eFoto && this.eFoto.getAttribute('src')) || '';
    this.herstel();

    // Niets opgeslagen? Dan begint iedereen op de voorbeeldmuur. De breedte
    // daarvan staat in de theme-editor, zodat er niet geijkt hoeft te worden.
    if (!this.state.foto && this.eFoto && this.eFoto.getAttribute('src')) {
      this.zetFoto(this.eFoto.getAttribute('src'), parseFloat(this.dataset.sampleWidth) || null);
    }
    this.tekenFotoKnop();

    window.addEventListener('resize', function () { el.teken(); });
  };

  GalleryWall.prototype.leesJSON = function (sel) {
    var s = this.querySelector(sel);
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  };

  GalleryWall.prototype.vind = function () {
    var q = this.querySelector.bind(this);
    this.eCanvas = q('[data-gw-canvas]');
    this.eFoto = q('[data-gw-photo]');
    this.eLaag = q('[data-gw-items]');
    this.eOver = q('[data-gw-overlay]');
    this.eFile = q('[data-gw-file]');
    this.eGatFile = q('[data-gw-photo-file]');
    this.eSample = q('[data-gw-sample]');
    this.eSampleLabel = q('[data-gw-sample-label]');
    this.eIjk = q('[data-gw-calib]');
    this.eTitel = q('[data-gw-title]');
    this.eHeroTekst = q('.gw__hero-tekst');
    this.eCm = q('[data-gw-cm]');
    this.eFout = q('[data-gw-error]');
    this.eMelding = q('[data-gw-toast]');
    this.eGroepen = q('[data-gw-groups]');
    this.eLijstKaarten = q('[data-gw-frame-cards]');
    this.ePpKaarten = q('[data-gw-mat-cards]');
    this.eLijst = q('[data-gw-list]');
  };

  GalleryWall.prototype.knoppen = function () {
    var el = this;
    var aan = function (sel, fn) {
      var n = el.querySelector(sel);
      if (n) n.addEventListener('click', fn);
    };
    aan('[data-gw-upload]', function () { el.eFile.click(); });
    aan('[data-gw-sample]', function () { el.wisselFoto(); });
    aan('[data-gw-calib-done]', function () { el.zetMaat(); });
    aan('[data-gw-recalib]', function () { el.startIjken(); });
    aan('[data-gw-cart]', function () { el.naarWinkelwagen(); });

    // Stap terug staat naast de uploadknop op de foto. Hij wordt hier gemaakt
    // zodat de sectie en de proefpagina's niet hoeven te veranderen.
    var rij = this.querySelector('.gw__fotoknoppen');
    if (rij) {
      this.eTerugStap = document.createElement('button');
      this.eTerugStap.type = 'button';
      this.eTerugStap.className = 'gw__upload gw__stapterug';
      this.eTerugStap.hidden = true;
      this.eTerugStap.innerHTML = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" ' +
        'stroke="currentColor" stroke-width="1.3" aria-hidden="true">' +
        '<path d="M2.6 8.2A5 5 0 107.5 2.5H4.6"/><path d="M6.3 0.9L4.6 2.5l1.7 1.7"/></svg><span></span>';
      this.eTerugStap.lastChild.textContent = this.t.stapTerug;
      this.eTerugStap.addEventListener('click', function () { el.stapTerug(); });
      rij.appendChild(this.eTerugStap);
    }
    // Cmd-Z of Ctrl-Z, behalve als iemand in een tekstveld aan het typen is.
    document.addEventListener('keydown', function (e) {
      if (!(e.metaKey || e.ctrlKey) || e.shiftKey || e.altKey) return;
      if (String(e.key).toLowerCase() !== 'z') return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(input|textarea|select)$/i.test(t.tagName))) return;
      if (!el.geschiedenis.length) return;
      e.preventDefault();
      el.stapTerug();
    });

    if (this.eFile) {
      this.eFile.addEventListener('change', function (e) {
        if (e.target.files && e.target.files[0]) el.leesBestand(e.target.files[0]);
      });
    }
    if (this.eGatFile) {
      this.eGatFile.addEventListener('change', function (e) {
        if (e.target.files && e.target.files[0]) el.zetGatFoto(e.target.files[0]);
      });
    }
    ['dragenter', 'dragover'].forEach(function (n) {
      el.eCanvas.addEventListener(n, function (e) { e.preventDefault(); });
    });
    el.eCanvas.addEventListener('drop', function (e) {
      e.preventDefault();
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) el.leesBestand(f);
    });
    this.querySelectorAll('[data-gw-chip]').forEach(function (c) {
      c.addEventListener('click', function () {
        el.eCm.value = c.dataset.gwChip;
        el.eCm.focus();
      });
    });
    if (this.eCm) {
      this.eCm.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); el.zetMaat(); }
      });
    }
    this.querySelectorAll('[data-gw-search]').forEach(function (inp) {
      inp.addEventListener('input', function () { el.zeef(inp.dataset.gwSearch); });
    });
  };

  /* ---------- zoeken en filteren ---------- */

  // Eén plek waar bepaald wordt welke kaarten blijven staan: de zoekterm en het
  // gekozen collectiefilter gelden allebei tegelijk.
  GalleryWall.prototype.zeef = function (soort) {
    var doel = soort === 'frames' ? this.eLijstKaarten : this.ePpKaarten;
    if (!doel) return;
    var veld = this.querySelector('[data-gw-search="' + soort + '"]');
    var term = veld ? veld.value.toLowerCase().trim() : '';
    var groep = soort === 'frames' ? '' : this.groep;
    var leden = null;
    if (groep) {
      this.groepen.forEach(function (g) {
        if (g.handle === groep) leden = g.producten || [];
      });
    }
    var zichtbaar = 0;
    doel.querySelectorAll('.gw__kaart').forEach(function (k) {
      var past = (!term || k.dataset.zoek.indexOf(term) !== -1) &&
                 (!leden || leden.indexOf(k.dataset.handle) !== -1);
      k.hidden = !past;
      if (past) zichtbaar++;
    });
    var leeg = doel.parentNode.querySelector('[data-gw-cards-empty]');
    if (leeg) leeg.hidden = zichtbaar > 0;
    doel.scrollLeft = 0;
  };

  // De knopjes naast het zoekveld. Bij één collectie heeft filteren geen zin,
  // dan blijft de rij leeg.
  GalleryWall.prototype.tekenGroepen = function () {
    var el = this;
    if (!this.eGroepen || this.groepen.length < 2) return;
    var maak = function (naam, handle) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gw__groep' + (el.groep === handle ? ' is-aan' : '');
      b.textContent = naam;
      b.setAttribute('aria-pressed', el.groep === handle ? 'true' : 'false');
      b.addEventListener('click', function () {
        el.groep = el.groep === handle ? '' : handle;
        el.tekenGroepen();
        el.zeef('mats');
      });
      return b;
    };
    this.eGroepen.innerHTML = '';
    this.eGroepen.appendChild(maak(this.dataset.labelAll || 'Alles', ''));
    this.groepen.forEach(function (g) {
      el.eGroepen.appendChild(maak(korteNaam(g.naam), g.handle));
    });
  };

  // "Organic shapes - passe-partouts" is als knopje te lang; wat erachter staat
  // zegt toch al waar je bent.
  function korteNaam(naam) {
    return String(naam || '').replace(/\s*[-\u2013]\s*passe-?partouts?\s*$/i, '').trim();
  }

  GalleryWall.prototype.melding = function (tekst) {
    if (!this.eMelding) return;
    var el = this;
    this.eMelding.textContent = tekst;
    this.eMelding.classList.add('is-zichtbaar');
    clearTimeout(this._meldingTimer);
    this._meldingTimer = setTimeout(function () {
      el.eMelding.classList.remove('is-zichtbaar');
    }, 2200);
  };

  /* ---------- foto ---------- */

  GalleryWall.prototype.leesBestand = function (file) {
    var el = this;
    if (file.size > MAX_BESTAND) { alert(this.dataset.errBig); return; }
    var url = URL.createObjectURL(file);
    laadAfbeelding(url).then(function (img) {
      var s = Math.min(1, MAX_FOTO_PX / Math.max(img.naturalWidth, img.naturalHeight));
      var c = document.createElement('canvas');
      c.width = Math.round(img.naturalWidth * s);
      c.height = Math.round(img.naturalHeight * s);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      el.zetFoto(c.toDataURL('image/jpeg', 0.86), null);
    }).catch(function () {
      URL.revokeObjectURL(url);
      alert(el.dataset.errRead);
    });
  };

  // fotoCm meegeven slaat het ijken over; dat doet de voorbeeldmuur, waarvan de
  // breedte in de theme-editor is ingesteld — de breedte van de hele foto.
  GalleryWall.prototype.zetFoto = function (src, fotoCm) {
    var el = this;
    laadAfbeelding(src).then(function (img) {
      // Twee eigen foto's tegelijk bewaren past niet in localStorage. Komt er
      // een nieuwe eigen foto, dan vervalt de vorige terugweg — tenzij dat de
      // voorbeeldmuur is, want die is maar een adres en kost niets.
      if (src !== el.voorbeeldSrc && el.state.anders && el.state.anders.foto !== el.voorbeeldSrc) {
        el.state.anders = null;
      }
      el.state.foto = src;
      el.state.ar = img.naturalHeight / img.naturalWidth;
      el.state.ijk = null;
      el.state.fotoCm = fotoCm || null;
      el.state.items = [];
      el.state.gekozen = null;
      el.wisGeschiedenis();
      el.eFoto.src = src;
      if (fotoCm) { el.toonIjken(false); el.teken(); }
      else el.startIjken();
      el.bewaar();
      el.tekenLijst();
      el.tekenFotoKnop();
    }).catch(function () { alert(el.dataset.errRead); });
  };

  // Wisselt tussen de voorbeeldmuur en de eigen foto van de klant. Allebei de
  // kanten houden hun eigen lijsten en hun eigen maatvoering vast, zodat even
  // op de voorbeeldmuur kijken niet betekent dat je opnieuw moet beginnen.
  GalleryWall.prototype.wisselFoto = function () {
    var el = this;
    if (!this.state.foto) return;
    var huidig = {
      foto: this.state.foto,
      ar: this.state.ar,
      ijk: this.state.ijk,
      fotoCm: this.state.fotoCm,
      items: this.state.items,
      gekozen: null
    };
    var terug = this.state.anders;

    if (terug && terug.foto) {
      this.state.anders = huidig;
      this.state.foto = terug.foto;
      this.state.ar = terug.ar;
      this.state.ijk = terug.ijk;
      this.state.fotoCm = terug.fotoCm;
      this.state.items = terug.items || [];
      this.state.gekozen = null;
      this.wisGeschiedenis();
      this.eFoto.src = terug.foto;
      if (terug.fotoCm) this.toonIjken(false);
      else this.startIjken();
      // De foto moet geladen zijn voordat de maten kloppen; tekenen doen we
      // daarom nog een keer zodra hij binnen is.
      this.eFoto.addEventListener('load', function () { el.teken(); el.tekenLijst(); }, { once: true });
      this.bewaar();
      this.teken();
      this.tekenLijst();
      this.tekenFotoKnop();
      return;
    }

    // Nog nooit gewisseld: dan gaat het naar de voorbeeldmuur, en de eigen
    // foto blijft met alles erop bewaard voor de terugweg.
    if (!this.voorbeeldSrc || huidig.foto === this.voorbeeldSrc) return;
    this.state.anders = huidig;
    this.zetFoto(this.voorbeeldSrc, parseFloat(this.dataset.sampleWidth) || null);
  };

  // De knop wijst altijd naar de andere kant. Op de voorbeeldmuur staat hij er
  // alleen als er een eigen foto is om naar terug te keren.
  GalleryWall.prototype.tekenFotoKnop = function () {
    if (!this.eSample) return;
    var opVoorbeeld = !!this.voorbeeldSrc && this.state.foto === this.voorbeeldSrc;
    var terug = this.state.anders;
    var toon = !!this.voorbeeldSrc && (opVoorbeeld ? !!(terug && terug.foto) : !!this.state.foto);
    this.eSample.hidden = !toon;
    if (toon && this.eSampleLabel) {
      this.eSampleLabel.textContent = opVoorbeeld ? this.t.terugEigen : this.t.terugVoorbeeld;
    }
  };

  /* ---------- ijken ---------- */

  // Het ijkblok verschijnt boven de titel, naast de foto. De titel blijft
  // staan: die hoort bij de pagina, niet bij de stap.
  GalleryWall.prototype.toonIjken = function (aan) {
    if (this.eIjk) this.eIjk.hidden = !aan;
    this.classList.toggle('is-ijken', aan);
  };

  GalleryWall.prototype.startIjken = function () {
    if (!this.state.ijk) {
      this.state.ijk = { x1: 0.22, y1: 0.55, x2: 0.62, y2: 0.55, cm: null };
    }
    if (this.eFout) this.eFout.textContent = '';
    this.toonIjken(true);
    this.teken();
  };

  GalleryWall.prototype.zetMaat = function () {
    var cm = parseFloat(String(this.eCm.value).replace(',', '.'));
    if (!cm || cm <= 0) { this.eFout.textContent = this.dataset.errCm; return; }
    var b = this.eCanvas.getBoundingClientRect();
    var k = this.state.ijk;
    var dx = (k.x2 - k.x1) * b.width, dy = (k.y2 - k.y1) * b.height;
    var lengte = Math.sqrt(dx * dx + dy * dy);
    if (lengte < b.width * 0.07) { this.eFout.textContent = this.dataset.errShort; return; }
    this.state.ijk.cm = cm;
    var breed = this.fotoBreedtePx();
    if (!breed) return;
    this.state.fotoCm = cm * (breed / lengte);
    this.eFout.textContent = '';
    this.toonIjken(false);
    this.bewaar();
    this.teken();
  };

  // De foto ligt met object-fit: cover in het vak, dus er valt links en rechts
  // (of boven en onder) iets af, en hoeveel dat is hangt van het venster af.
  // Daarom hangt de maat aan de foto zelf en niet aan het vak: state.fotoCm is
  // hoe breed de hele foto in het echt is. Anders klopt de ware grootte alleen
  // op het scherm waarop hij is ingesteld.
  GalleryWall.prototype.fotoBreedtePx = function () {
    if (!this.eFoto || !this.eCanvas) return 0;
    var b = this.eCanvas.getBoundingClientRect();
    var iw = this.eFoto.naturalWidth, ih = this.eFoto.naturalHeight;
    if (!iw || !ih || !b.width || !b.height) return 0;
    return iw * Math.max(b.width / iw, b.height / ih);
  };

  GalleryWall.prototype.pxPerCm = function () {
    if (!this.state.fotoCm) return null;
    var breed = this.fotoBreedtePx();
    if (!breed) return null;
    return breed / this.state.fotoCm;
  };

  // Hoe breed het zichtbare stuk muur in het echt is; daarbinnen blijven de
  // stukken op de muur.
  GalleryWall.prototype.muurCm = function () {
    var ppc = this.pxPerCm();
    if (!ppc) return 0;
    return this.eCanvas.getBoundingClientRect().width / ppc;
  };

  /* ---------- tekenen ---------- */

  GalleryWall.prototype.teken = function () {
    if (!this.state.foto) return;
    this.tekenOverlay();
    this.tekenItems();
  };

  GalleryWall.prototype.tekenOverlay = function () {
    var b = this.eCanvas.getBoundingClientRect();
    if (!b.width) return;
    var svg = this.eOver;
    svg.setAttribute('viewBox', '0 0 ' + Math.round(b.width) + ' ' + Math.round(b.height));
    if (!this.classList.contains('is-ijken')) { svg.innerHTML = ''; return; }
    var k = this.state.ijk;
    var x1 = k.x1 * b.width, y1 = k.y1 * b.height;
    var x2 = k.x2 * b.width, y2 = k.y2 * b.height;
    // met een vinger moet je de handvatten kunnen pakken; met de muis mogen
    // ze kleiner en daarmee nauwkeuriger
    var grof = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    var r = grof ? Math.max(11, Math.min(17, b.width * 0.028))
                 : Math.max(9, Math.min(16, b.width * 0.018));
    var raakR = grof ? r + 9 : r;   // onzichtbare rand eromheen voor de vinger
    svg.innerHTML =
      '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"' +
        ' stroke="#fff" stroke-width="4" stroke-linecap="round" opacity=".85"/>' +
      '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"' +
        ' stroke="#1D1D1B" stroke-width="1.6" stroke-linecap="round" stroke-dasharray="7 5"/>' +
      '<circle cx="' + x1 + '" cy="' + y1 + '" r="' + r + '" fill="#fff" stroke="#1D1D1B"' +
        ' stroke-width="1.6" class="gw__handle"/>' +
      '<circle cx="' + x2 + '" cy="' + y2 + '" r="' + r + '" fill="#fff" stroke="#1D1D1B"' +
        ' stroke-width="1.6" class="gw__handle"/>' +
      '<circle cx="' + x1 + '" cy="' + y1 + '" r="' + raakR + '" fill="transparent"' +
        ' data-handle="1" class="gw__handle"/>' +
      '<circle cx="' + x2 + '" cy="' + y2 + '" r="' + raakR + '" fill="transparent"' +
        ' data-handle="2" class="gw__handle"/>';
    if (!this._ijkAan) { this._ijkAan = true; this.ijkSlepen(); }
  };

  GalleryWall.prototype.ijkSlepen = function () {
    var el = this, actief = null;
    function naar(e) {
      var b = el.eCanvas.getBoundingClientRect();
      return {
        x: Math.max(0, Math.min(1, (e.clientX - b.left) / b.width)),
        y: Math.max(0, Math.min(1, (e.clientY - b.top) / b.height))
      };
    }
    this.eOver.addEventListener('pointerdown', function (e) {
      var h = e.target.getAttribute && e.target.getAttribute('data-handle');
      if (!h) return;
      actief = h;
      e.target.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    this.eOver.addEventListener('pointermove', function (e) {
      if (!actief) return;
      var p = naar(e);
      if (actief === '1') { el.state.ijk.x1 = p.x; el.state.ijk.y1 = p.y; }
      else { el.state.ijk.x2 = p.x; el.state.ijk.y2 = p.y; }
      el.tekenOverlay();
    });
    this.eOver.addEventListener('pointerup', function () { actief = null; });
    this.eOver.addEventListener('pointercancel', function () { actief = null; });
  };

  /* ---------- productkaarten ---------- */

  GalleryWall.prototype.tekenKaarten = function () {
    var el = this;
    // maakKaart geeft niets terug als er geen formaat uit de varianten te lezen
    // valt. In de collectie Wissellijsten zit bijvoorbeeld de kioskfotolijst,
    // waarvan de varianten alleen kleuren zijn; zonder deze controle strandde
    // het hele opstarten daarop en bleef de rij passe-partouts leeg.
    if (this.eLijstKaarten) {
      this.lijsten.forEach(function (p) {
        var kaart = p.rvs ? el.maakRvsKaart(p)
                  : isKleurLijst(p) ? el.maakKioskKaart(p)
                  : el.maakKaart(p, 'lijst');
        if (kaart) el.eLijstKaarten.appendChild(kaart);
      });
    }
    // Eén kaart per product, ook als er binnenformaten zijn: die worden een
    // keuzevakje, net als op de productpagina. Een kaart per binnenformaat gaf
    // drie keer dezelfde foto naast elkaar.
    if (this.ePpKaarten) {
      this.ppProducten.forEach(function (p) {
        var kaart = el.maakKaart(p, 'pp');
        if (kaart) el.ePpKaarten.appendChild(kaart);
      });
    }
  };

  // De formaten van een product, met de maat in centimeters erbij.
  // Wissellijsten leveren ze als lijst mee, passe-partouts zitten in de
  // variantnamen.
  function maatLijst(product) {
    var uit = (product.formaten || []).map(function (f) {
      var m = leesFormaat(f.naam);
      if (!m) return null;
      return {
        // niet de hele varianttitel in het keuzevakje, daar staat de kleur in
        naam: maatDeel(f.naam) || f.naam, w: m.w, h: m.h,
        variant: f.variant, prijs: f.prijs,
        beschikbaar: f.voorraad !== false && f.beschikbaar !== false
      };
    }).filter(Boolean);
    return uit.length ? uit : formatenVan(product);
  }

  // Welke buitenformaten heeft dit product? Uit de variantnamen gelezen,
  // zodat een nieuw formaat in de admin vanzelf meekomt.
  function formatenVan(product) {
    var gezien = {}, uit = [];
    (product.varianten || []).forEach(function (v) {
      var titel = zonderBinnen(v.titel, product.binnenformaten);
      var deel = maatDeel(titel);
      var maat = leesFormaat(deel) || leesFormaat(titel);
      if (!maat) return;
      var sleutel = maat.w + 'x' + maat.h;
      if (gezien[sleutel]) return;
      gezien[sleutel] = true;
      uit.push({ naam: deel, w: maat.w, h: maat.h });
    });
    // Vijf passe-partouts hebben helemaal geen formaatoptie — "30x40 cm
    // fotostrip (kioskfoto)" heeft alleen kleuren als varianten, en het formaat
    // staat in de producttitel. Zonder deze terugval vielen die producten uit de
    // rij, want een kaart zonder formaat wordt niet gemaakt.
    // Staat de maat niet in de variant, dan eerst het metafield
    // custom.buitenformaat en pas daarna de producttitel. In een titel als
    // "15x20 foto passe-partout in de hoek, 50x70 cm" staat de foto vóór het
    // buitenformaat, en de titel zou dan 15x20 opleveren. uitTitel betekent:
    // niet in de variant, dus bij het zoeken alleen op kleur en binnenformaat.
    if (!uit.length) {
      (product.buitenformaten || []).forEach(function (b) {
        var m = leesFormaat(b);
        if (!m || uit.some(function (u) { return u.w === m.w && u.h === m.h; })) return;
        uit.push({ naam: formaatNaam(m), w: m.w, h: m.h, uitTitel: true });
      });
    }
    if (!uit.length) {
      var uitTitel = leesFormaat(product.titel || product.naam);
      if (uitTitel) {
        uit.push({
          naam: formaatNaam(uitTitel), w: uitTitel.w, h: uitTitel.h, uitTitel: true
        });
      }
    }
    return uit;
  }

  // 21x29.7 -> "21x29,7 cm", zoals het in de winkel geschreven staat
  function formaatNaam(m) {
    return String(m.w).replace('.', ',') + 'x' + String(m.h).replace('.', ',') + ' cm';
  }

  // Een keuzevakje met het woord erboven. Zonder dat label leest "A4 / 21x29,7
  // cm" of "White Like A Wave" als een gegeven en niet als iets wat je kunt
  // openklappen — op een telefoon viel daardoor niet op dat de kleur te kiezen
  // is.
  function keuzeVak(labelTekst) {
    var wrap = document.createElement('label');
    wrap.className = 'gw__keuze';
    var lab = document.createElement('span');
    lab.className = 'gw__keuze-label';
    lab.textContent = labelTekst;
    var vak = document.createElement('span');
    vak.className = 'gw__keuze-vak';
    var sel = document.createElement('select');
    sel.className = 'gw__kies';
    sel.setAttribute('aria-label', labelTekst);
    vak.appendChild(sel);
    wrap.appendChild(lab);
    wrap.appendChild(vak);
    return { wrap: wrap, vak: vak, select: sel };
  }

  GalleryWall.prototype.maakKaart = function (product, soort) {
    var el = this;
    var formaten = maatLijst(product);
    if (!formaten.length) return null;
    var binnen = soort === 'pp' ? (product.binnenformaten || []) : [];

    var kaart = document.createElement('article');
    kaart.className = 'gw__kaart';
    kaart.dataset.zoek = ((product.naam || product.titel) + ' ' + binnen.join(' ')).toLowerCase();
    kaart.dataset.handle = product.handle || '';

    var beeld = document.createElement('div');
    beeld.className = 'gw__kaart-beeld';
    if (product.foto) {
      var img = document.createElement('img');
      img.src = product.foto;
      img.alt = '';
      img.loading = 'lazy';
      beeld.appendChild(img);
    }
    var badges = document.createElement('div');
    badges.className = 'gw__badges';
    if (soort === 'pp') badges.appendChild(el.badge(el.dataset.badgeColors || 'MEER KLEUREN', 'kleuren'));
    if (formaten.length > 1) badges.appendChild(el.badge(el.dataset.badgeSizes || 'MEER MATEN', 'maten'));
    if (badges.children.length) beeld.appendChild(badges);
    if (product.bestseller) {
      var rechts = document.createElement('div');
      rechts.className = 'gw__badges gw__badges--rechts';
      rechts.appendChild(el.badge(el.dataset.badgeBest || 'BESTSELLER', 'bestseller'));
      beeld.appendChild(rechts);
    }
    kaart.appendChild(beeld);

    var titel = document.createElement('h3');
    titel.className = 'gw__kaart-titel';
    titel.textContent = product.naam || product.titel;
    kaart.appendChild(titel);

    var keuzes = document.createElement('div');
    keuzes.className = 'gw__kaart-keuzes';

    var binnenSel = null;
    if (binnen.length > 1) {
      var binnenVak = keuzeVak(el.t.binnenformaat);
      binnenSel = binnenVak.select;
      optiesIn(binnenSel, binnen);
      keuzes.appendChild(binnenVak.wrap);
    }
    var gekozenBinnen = function () {
      return binnen.length ? binnen[binnenSel ? binnenSel.value | 0 : 0] : null;
    };

    var maatVak = keuzeVak(el.dataset.labelSize || 'Formaat');
    var maat = maatVak.select;
    // Niet elk binnenformaat bestaat op elk buitenformaat (de 12x polaroid
    // square bijvoorbeeld niet op elke maat). Het formaatvakje toont daarom
    // alleen de maten waar het gekozen binnenformaat een variant voor heeft.
    var zichtbaar = formaten;
    var vulMaten = function () {
      var b = gekozenBinnen();
      var vorige = zichtbaar[maat.value | 0];
      zichtbaar = !b ? formaten : formaten.filter(function (f) {
        return f.uitTitel || zoekVariant(product.varianten, [b], { w: f.w, h: f.h }, binnen);
      });
      if (!zichtbaar.length) zichtbaar = formaten;
      maat.innerHTML = '';
      var kies = 0;
      zichtbaar.forEach(function (f, i) {
        var o = document.createElement('option');
        o.value = i;
        o.textContent = f.naam;
        maat.appendChild(o);
        if (vorige && f.w === vorige.w && f.h === vorige.h) kies = i;
      });
      maat.value = kies;
    };
    vulMaten();
    if (binnenSel) binnenSel.addEventListener('change', vulMaten);
    keuzes.appendChild(maatVak.wrap);

    var kleur = null;
    if (soort === 'pp' && el.kleuren.length) {
      var kleurVak = el.kartonKeuze(el.dataset.labelColor || 'Kleur');
      kleur = kleurVak.select;
      keuzes.appendChild(kleurVak.wrap);
    }
    kaart.appendChild(keuzes);

    var knop = document.createElement('button');
    knop.type = 'button';
    knop.className = 'gw__toevoegen';
    knop.textContent = el.dataset.addLabel || 'Zet op de muur';
    knop.addEventListener('click', function () {
      var f = zichtbaar[maat.value | 0];
      if (soort === 'lijst') el.voegLijstToe(product, f);
      else el.voegPpToe(product, f, gekozenBinnen(), kleur ? el.kleuren[kleur.value | 0] : null);
    });
    kaart.appendChild(knop);
    return kaart;
  };

  // Keuzevakje met de kartonkleuren, met een stip ervoor, zodat je de kleur
  // ziet en niet alleen de naam leest: "White Like A Wave" zegt weinig als je
  // het assortiment niet kent.
  GalleryWall.prototype.kartonKeuze = function (label) {
    var el = this;
    var vak = keuzeVak(label);
    var kleur = vak.select;
    kleur.classList.add('gw__kies--kleur');
    var stip = document.createElement('span');
    stip.className = 'gw__stip';
    vak.vak.insertBefore(stip, kleur);
    el.kleuren.forEach(function (k, i) {
      var o = document.createElement('option');
      o.value = i;
      o.textContent = k.naam;
      kleur.appendChild(o);
    });
    var zetStip = function () {
      var k = el.kleuren[kleur.value | 0] || {};
      stip.style.background = k.hex || 'transparent';
      stip.style.backgroundImage = k.staal ? 'url(' + k.staal + ')' : '';
      stip.style.backgroundSize = 'cover';
    };
    zetStip();
    kleur.addEventListener('change', zetStip);
    return vak;
  };

  // Het begin van elke kaart: foto, badges en titel.
  GalleryWall.prototype.kaartRomp = function (product, badges) {
    var el = this;
    var kaart = document.createElement('article');
    kaart.className = 'gw__kaart';
    kaart.dataset.zoek = String(product.naam || product.titel).toLowerCase();
    kaart.dataset.handle = product.handle || '';
    var beeld = document.createElement('div');
    beeld.className = 'gw__kaart-beeld';
    if (product.foto) {
      var img = document.createElement('img');
      img.src = product.foto;
      img.alt = '';
      img.loading = 'lazy';
      beeld.appendChild(img);
    }
    if (badges.length) {
      var rij = document.createElement('div');
      rij.className = 'gw__badges';
      badges.forEach(function (b) { rij.appendChild(el.badge(b[0], b[1])); });
      beeld.appendChild(rij);
    }
    kaart.appendChild(beeld);
    var titel = document.createElement('h3');
    titel.className = 'gw__kaart-titel';
    titel.textContent = product.naam || product.titel;
    kaart.appendChild(titel);
    var keuzes = document.createElement('div');
    keuzes.className = 'gw__kaart-keuzes';
    kaart.appendChild(keuzes);
    return { kaart: kaart, keuzes: keuzes };
  };

  GalleryWall.prototype.kaartKnop = function (romp, fn) {
    var knop = document.createElement('button');
    knop.type = 'button';
    knop.className = 'gw__toevoegen';
    knop.textContent = this.dataset.addLabel || 'Zet op de muur';
    knop.addEventListener('click', fn);
    romp.kaart.appendChild(knop);
    return romp.kaart;
  };

  function optiesIn(select, namen) {
    namen.forEach(function (n, i) {
      var o = document.createElement('option');
      o.value = i;
      o.textContent = n;
      select.appendChild(o);
    });
  }

  // Een wissellijst waarvan de varianten kleuren zijn in plaats van maten: de
  // kioskfoto-lijst. De maat staat in de producttitel (15x35 cm), de kleur
  // van het karton en de maat van de strip gaan als regeleigenschap mee, net
  // als op de productpagina.
  function isKleurLijst(p) {
    var f = p.formaten || [];
    return !p.rvs && f.length > 0 && !!leesFormaat(p.naam) &&
           f.every(function (v) { return !leesFormaat(v.naam); });
  }

  GalleryWall.prototype.maakKioskKaart = function (product) {
    var el = this, U = window.GalleryWallUitsneden;
    var maat = leesFormaat(product.naam);
    if (!maat || !U) return null;
    var romp = this.kaartRomp(product, [[el.dataset.badgeColors || 'MEER KLEUREN', 'kleuren']]);

    var lijstVak = keuzeVak(el.t.lijstKleur);
    optiesIn(lijstVak.select, product.formaten.map(function (f) {
      return f.naam + (f.voorraad === false ? ' (' + el.t.uitverkocht + ')' : '');
    }));
    romp.keuzes.appendChild(lijstVak.wrap);

    var kartonVak = el.kleuren.length ? el.kartonKeuze(el.t.ppKleur) : null;
    if (kartonVak) romp.keuzes.appendChild(kartonVak.wrap);

    var strips = Object.keys(U.strip).map(function (k) { return k + ' cm'; });
    var stripVak = keuzeVak(el.t.stripMaat);
    optiesIn(stripVak.select, strips);
    romp.keuzes.appendChild(stripVak.wrap);

    return this.kaartKnop(romp, function () {
      el.voegKioskToe(product, maat, product.formaten[lijstVak.select.value | 0],
        kartonVak ? el.kleuren[kartonVak.select.value | 0] : null,
        strips[stripVak.select.value | 0]);
    });
  };

  // RVS: één maat, en als er meer varianten zijn, dan zijn dat binnenformaten.
  GalleryWall.prototype.maakRvsKaart = function (product) {
    var el = this, U = window.GalleryWallUitsneden;
    var spec = U && U.rvs(product.handle);
    var varianten = product.formaten || [];
    if (!spec || !varianten.length) return null;
    var romp = this.kaartRomp(product, []);
    var maatVak = keuzeVak(el.dataset.labelSize || 'Formaat');
    optiesIn(maatVak.select, [formaatNaam({ w: spec.buiten[0], h: spec.buiten[1] })]);
    romp.keuzes.appendChild(maatVak.wrap);
    var binnenVak = null;
    if (varianten.length > 1) {
      binnenVak = keuzeVak(el.t.binnenformaat);
      optiesIn(binnenVak.select, varianten.map(function (v) {
        return v.naam + (v.voorraad === false ? ' (' + el.t.uitverkocht + ')' : '');
      }));
      romp.keuzes.appendChild(binnenVak.wrap);
    }
    return this.kaartKnop(romp, function () {
      el.voegRvsToe(product, spec, varianten[binnenVak ? binnenVak.select.value | 0 : 0]);
    });
  };

  // soort: 'kleuren' (geel), 'maten' (olijf) of 'bestseller' (bordeaux)
  GalleryWall.prototype.badge = function (tekst, soort) {
    var s = document.createElement('span');
    s.className = 'gw__badge' + (soort && soort !== 'kleuren' ? ' gw__badge--' + soort : '');
    s.textContent = tekst;
    return s;
  };

  /* ---------- dingen op de muur ---------- */

  GalleryWall.prototype.nieuwePlek = function (w, h) {
    var b = this.eCanvas.getBoundingClientRect();
    var ppc = this.pxPerCm();
    var muur = this.muurCm();
    var muurH = b.height / ppc;
    // iets verspringen zodat een tweede stuk niet precies op het eerste valt
    var n = this.state.items.length;
    return {
      x: Math.max(1, Math.min(muur - w - 1, muur / 2 - w / 2 + (n % 5) * 3)),
      y: Math.max(1, Math.min(muurH - h - 1, muurH / 2 - h / 2 + (n % 3) * 3))
    };
  };

  GalleryWall.prototype.voegItemToe = function (item) {
    if (!this.pxPerCm()) return;
    this.onthoud();
    var plek = this.nieuwePlek(item.w, item.h);
    item.id = 'i' + Date.now() + Math.round(Math.random() * 999);
    item.x = plek.x;
    item.y = plek.y;
    this.state.items.push(item);
    this.state.gekozen = item.id;
    this.bewaar();
    this.tekenItems();
    this.tekenLijst();
  };

  GalleryWall.prototype.voegLijstToe = function (product, formaat) {
    // Wissellijsten dragen hun variant al bij zich; anders zoeken we hem op.
    var v = formaat.variant ? formaat
      : zoekVariant(product.varianten, [], { w: formaat.w, h: formaat.h });
    this.voegItemToe({
      w: formaat.w, h: formaat.h,
      lijst: {
        handle: product.handle, naam: product.naam || product.titel, foto: product.foto,
        formaat: formaat.naam,
        variant: v && (v.variant || v.id),
        prijs: v && v.prijs,
        beschikbaar: v ? v.beschikbaar !== false : false
      },
      pp: null
    });
  };

  // De kioskfoto-lijst: lijst en karton zijn één product. Het profiel komt van
  // de gewone wissellijst in dezelfde kleur (custom.kleurnaam is gelijk aan de
  // varianttitel), want de kioskfoto zelf heeft geen foto per lijstkleur.
  GalleryWall.prototype.voegKioskToe = function (product, maat, variant, kleur, strip) {
    if (!variant) return;
    var bron = this.lijsten.filter(function (l) {
      return !l.rvs && l.kleurnaam && l.kleurnaam === variant.naam;
    })[0];
    this.voegItemToe({
      w: maat.w, h: maat.h,
      lijst: {
        handle: product.handle, naam: product.naam,
        foto: (bron && bron.foto) || product.foto,
        kleur: variant.naam, formaat: formaatNaam(maat),
        variant: variant.variant, prijs: variant.prijs,
        beschikbaar: variant.voorraad !== false
      },
      pp: { inbegrepen: true, kleur: kleur || null, binnenformaat: strip, formaat: formaatNaam(maat) }
    });
  };

  GalleryWall.prototype.voegRvsToe = function (product, spec, variant) {
    if (!variant) return;
    var titel = variant.naam === 'Default Title' ? null : variant.naam;
    this.voegItemToe({
      w: spec.buiten[0], h: spec.buiten[1],
      lijst: {
        rvs: true, handle: product.handle, naam: product.naam, foto: product.foto,
        formaat: formaatNaam({ w: spec.buiten[0], h: spec.buiten[1] }),
        binnenformaat: titel,
        variant: variant.variant, prijs: variant.prijs,
        beschikbaar: variant.voorraad !== false
      },
      pp: null
    });
  };

  // Een RVS-lijst hangt staand of liggend; dat is geen variant, dus alleen
  // de tekening draait. Om het midden, zodat hij niet wegspringt.
  GalleryWall.prototype.draai = function (id) {
    var it = this.state.items.filter(function (x) { return x.id === id; })[0];
    if (!isRvs(it)) return;
    this.onthoud();
    var cx = it.x + it.w / 2, cy = it.y + it.h / 2;
    var w = it.w;
    it.w = it.h;
    it.h = w;
    it.liggend = !it.liggend;
    var muurH = this.eCanvas.getBoundingClientRect().height / this.pxPerCm();
    it.x = Math.max(0, Math.min(this.muurCm() - it.w, cx - it.w / 2));
    it.y = Math.max(0, Math.min(muurH - it.h, cy - it.h / 2));
    this.bewaar();
    this.tekenItems();
    this.tekenLijst();
  };

  GalleryWall.prototype.voegPpToe = function (product, formaat, binnenformaat, kleur) {
    // Staat het formaat alleen in de producttitel, dan valt er in de varianttitel
    // niets over de maat te vinden; die bestaat dan alleen uit de kleur.
    var v = zoekVariant(product.varianten, [kleur && kleur.naam, binnenformaat],
      formaat.uitTitel ? null : { w: formaat.w, h: formaat.h }, product.binnenformaten);
    this.voegItemToe({
      w: formaat.w, h: formaat.h,
      lijst: null,
      pp: {
        handle: product.handle, naam: product.titel || product.naam,
        binnenformaat: binnenformaat || null,
        formaat: formaat.naam, kleur: kleur || null,
        variant: v && v.id, prijs: v && v.prijs,
        beschikbaar: v ? v.beschikbaar !== false : false
      }
    });
  };

  GalleryWall.prototype.gatenVan = function (it) {
    var U = window.GalleryWallUitsneden, K = window.GalleryWallKoppeling;
    if (U && isRvs(it)) {
      var v = U.rvsVenster(it.lijst.handle, it.lijst.binnenformaat);
      if (!v) return null;
      return U.midden(it.w, it.h, it.liggend ? [v[1], v[0]] : v);
    }
    if (U && it.pp && it.pp.inbegrepen) {
      return U.midden(it.w, it.h, U.stripVenster(it.pp.binnenformaat));
    }
    if (!U || !K || !it.pp) return null;
    var sleutel = K.ontwerpVan(it.pp.handle, it.pp.binnenformaat);
    if (!sleutel) return null;
    return U.gaten(sleutel, it.pp.formaat);
  };

  // De gaten liggen in centimeters vanaf de hoek van het passe-partout.
  // Zit er een lijst omheen, dan dekt die aan elke kant randCm af — dat is de
  // dikte waarmee hij getekend is, zodat de uitsnedes bij de zichtbare rand
  // van het karton blijven liggen.
  //
  // Per uitsnede komen er drie dingen over elkaar: de eigen foto van de klant
  // (bijgesneden op de vorm), de witte snijkant van het karton, en de omtrek.
  GalleryWall.prototype.tekenGaten = function (it, gaten, randCm) {
    var NS = 'http://www.w3.org/2000/svg';
    var p = randCm || 0;
    var fotos = (fotoDrager(it) || {}).fotos || {};
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'gw__gaten');
    svg.setAttribute('viewBox', p + ' ' + p + ' ' + (it.w - 2 * p) + ' ' + (it.h - 2 * p));
    svg.setAttribute('preserveAspectRatio', 'none');
    var defs = document.createElementNS(NS, 'defs');
    svg.appendChild(defs);

    gaten.forEach(function (g, i) {
      var n = gatVorm(g);
      if (!n) return;
      n.setAttribute('class', 'gw__gat');
      svg.appendChild(n);

      var id = 'gwgat-' + it.id + '-' + i;
      var knip = document.createElementNS(NS, 'clipPath');
      knip.setAttribute('id', id);
      knip.appendChild(gatVorm(g));
      defs.appendChild(knip);

      if (fotos[i]) {
        var beeld = document.createElementNS(NS, 'image');
        beeld.setAttribute('x', g.x);
        beeld.setAttribute('y', g.y);
        beeld.setAttribute('width', g.w);
        beeld.setAttribute('height', g.h);
        beeld.setAttribute('preserveAspectRatio', 'xMidYMid slice');
        beeld.setAttribute('clip-path', 'url(#' + id + ')');
        if (g.hoek) beeld.setAttribute('transform', gatDraai(g));
        beeld.setAttribute('href', fotos[i]);
        svg.appendChild(beeld);
      }

      // De kern van het karton is wit en de snede staat schuin; die lichte
      // rand van ongeveer anderhalve millimeter maakt dat je ziet dat het
      // karton dikte heeft. Halve streekbreedte valt binnen de vorm weg door
      // het knippad, dus we tekenen hem dubbel zo dik.
      var kant = gatVorm(g);
      kant.setAttribute('class', 'gw__gat-kant');
      kant.setAttribute('clip-path', 'url(#' + id + ')');
      svg.appendChild(kant);
    });
    return svg;
  };

  // Eén uitsnede als svg-vorm, op zijn plek en onder zijn hoek.
  function gatVorm(g) {
    var NS = 'http://www.w3.org/2000/svg';
    var V = window.GalleryWallVormen;
    var n;
    if (g.vorm === 'rechthoek' || !V) {
      n = document.createElementNS(NS, 'rect');
      n.setAttribute('x', g.x); n.setAttribute('y', g.y);
      n.setAttribute('width', g.w); n.setAttribute('height', g.h);
    } else {
      var d = V.pad(g.vorm, g.w, g.h);
      if (!d) return null;
      n = document.createElementNS(NS, 'path');
      n.setAttribute('d', d);
      n.setAttribute('transform', 'translate(' + g.x + ' ' + g.y + ')');
    }
    if (g.hoek) {
      n.setAttribute('transform', gatDraai(g) + ' ' + (n.getAttribute('transform') || ''));
    }
    return n;
  }

  function gatDraai(g) {
    return 'rotate(' + g.hoek + ' ' + (g.x + g.w / 2) + ' ' + (g.y + g.h / 2) + ')';
  }

  /* ---------- eigen foto's in de uitsnedes ---------- */

  // De knoppen liggen als onzichtbare vlakken precies op de uitsnedes. Ze doen
  // pas iets als het stuk al geselecteerd was, anders opent er een bestands-
  // venster bij de eerste de beste klik. Slepen blijft overal werken: we kijken
  // achteraf of de muis bewogen heeft.
  GalleryWall.prototype.tekenGatKnoppen = function (it, gaten, randCm, ppc) {
    var el = this;
    var p = randCm || 0;
    var laag = document.createElement('div');
    laag.className = 'gw__gatknoppen';
    gaten.forEach(function (g, i) {
      var b = document.createElement('button');
      b.type = 'button';
      var heeft = !!((fotoDrager(it) || {}).fotos || {})[i];
      b.className = 'gw__gatknop' + (heeft ? ' is-vol' : '');
      b.style.left = ((g.x - p) * ppc) + 'px';
      b.style.top = ((g.y - p) * ppc) + 'px';
      b.style.width = (g.w * ppc) + 'px';
      b.style.height = (g.h * ppc) + 'px';
      if (g.hoek) b.style.transform = 'rotate(' + g.hoek + 'deg)';
      b.title = el.t.fotoKies;
      b.setAttribute('aria-label', el.t.fotoKies);
      // Het camerraatje krimpt mee met de uitsnede: op een echte wand is een
      // polaroidgaatje maar zo'n twintig pixels, en een vast icoon van 26 px
      // paste daar niet in. Onder de tien pixels laten we het weg; dan is er
      // toch niets meer te zien en blijft het vlak alleen klikbaar.
      var maat = Math.round(Math.max(10, Math.min(26, Math.min(g.w, g.h) * ppc * 0.78)));
      if (maat >= 10 && Math.min(g.w, g.h) * ppc >= 13) {
        b.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" ' +
          'stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M3.5 6.5h3l1-1.5h5l1 1.5h3v9h-13z"/><circle cx="10" cy="11" r="2.6"/></svg>';
        var icoon = b.firstChild;
        icoon.style.width = maat + 'px';
        icoon.style.height = maat + 'px';
        icoon.style.padding = Math.max(2, Math.round(maat * 0.18)) + 'px';
      }
      b.dataset.gat = i;
      // Muisklikken lopen via het loslaten van de sleep (zie itemSlepen): zolang
      // het item de pointer vasthoudt komt een klik nooit bij deze knop aan.
      // Wat hier binnenkomt is dus toetsenbord, en dat mag meteen door.
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        if (e.detail !== 0) return;
        el.kiesGatFoto(it, i);
      });
      laag.appendChild(b);
    });
    return laag;
  };

  GalleryWall.prototype.kiesGatFoto = function (it, i) {
    if (!this.eGatFile) return;
    this._gatDoel = { id: it.id, gat: i };
    this.eGatFile.value = '';
    this.eGatFile.click();
  };

  GalleryWall.prototype.zetGatFoto = function (file) {
    var el = this, doel = this._gatDoel;
    if (!doel) return;
    if (file.size > MAX_BESTAND) { alert(this.dataset.errBig); return; }
    var url = URL.createObjectURL(file);
    laadAfbeelding(url).then(function (img) {
      var s = Math.min(1, MAX_GATFOTO_PX / Math.max(img.naturalWidth, img.naturalHeight));
      var c = document.createElement('canvas');
      c.width = Math.round(img.naturalWidth * s);
      c.height = Math.round(img.naturalHeight * s);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      var it = el.state.items.filter(function (x) { return x.id === doel.id; })[0];
      var drager = it && fotoDrager(it);
      if (!drager) return;
      el.onthoud();
      if (!drager.fotos) drager.fotos = {};
      drager.fotos[doel.gat] = c.toDataURL('image/jpeg', 0.8);
      el.bewaar();
      el.tekenItems();
      el.tekenLijst();
    }).catch(function () {
      URL.revokeObjectURL(url);
      alert(el.dataset.errRead);
    });
  };

  GalleryWall.prototype.wisGatFotos = function (id) {
    var it = this.state.items.filter(function (x) { return x.id === id; })[0];
    var drager = it && fotoDrager(it);
    if (!drager) return;
    this.onthoud();
    drager.fotos = {};
    this.bewaar();
    this.tekenItems();
    this.tekenLijst();
  };

  function isRvs(it) { return !!(it && it.lijst && it.lijst.rvs); }

  // Waar de eigen foto's in de uitsnedes bewaard worden: bij het passe-partout,
  // of bij een RVS-lijst bij de lijst zelf.
  function fotoDrager(it) {
    if (!it) return null;
    return it.pp || (isRvs(it) ? it.lijst : null);
  }

  function heeftGatFotos(it) {
    var f = (fotoDrager(it) || {}).fotos;
    return !!(f && Object.keys(f).length);
  }

  GalleryWall.prototype.tekenItems = function () {
    var el = this;
    var ppc = this.pxPerCm();
    this.eLaag.innerHTML = '';
    if (!ppc) return;
    this.state.items.forEach(function (it) {
      // hoe dik de lijst hier op het scherm staat, en hoeveel van het
      // passe-partout hij daarmee afdekt
      var rvs = isRvs(it);
      var rand = it.lijst && !rvs ? Math.max(PROFIEL_MIN_PX, PROFIEL_TEKEN_CM * ppc) : 0;
      var randCm = rand / ppc;
      var d = document.createElement('div');
      d.className = 'gw__item' + (el.state.gekozen === it.id ? ' is-gekozen' : '') +
                    (it.lijst ? '' : ' gw__item--los-pp') + (rvs ? ' gw__item--rvs' : '');
      d.dataset.id = it.id;
      d.style.width = (it.w * ppc) + 'px';
      d.style.height = (it.h * ppc) + 'px';
      d.style.left = (it.x * ppc) + 'px';
      d.style.top = (it.y * ppc) + 'px';

      if (rvs) {
        // 2 cm diep, dus net zo zwaar op de muur als een wissellijst
        var sr = Math.max(1.4, PROFIEL_TEKEN_CM * ppc);
        d.style.boxShadow = (sr * 0.30).toFixed(1) + 'px ' + (sr * 0.5).toFixed(1) + 'px ' +
                            (sr * 1.2).toFixed(1) + 'px rgba(0,0,0,.26)';
      } else if (it.lijst) {
        d.style.borderWidth = rand.toFixed(2) + 'px';
        var s = Math.max(1.4, rand);
        d.style.boxShadow = (s * 0.30).toFixed(1) + 'px ' + (s * 0.5).toFixed(1) + 'px ' +
                            (s * 1.2).toFixed(1) + 'px rgba(0,0,0,.24)';
      } else {
        d.style.boxShadow = '1px 2px 5px rgba(0,0,0,.14)';
      }

      var binnen;
      if (rvs) {
        binnen = document.createElement('div');
        binnen.className = 'gw__rvs';
        var rg = el.gatenVan(it);
        if (rg && rg.length) {
          binnen.appendChild(el.tekenGaten(it, rg, 0));
          binnen.appendChild(el.tekenGatKnoppen(it, rg, 0, ppc));
        }
      } else if (it.pp) {
        binnen = document.createElement('div');
        binnen.className = 'gw__mat';
        binnen.style.background = (it.pp.kleur && it.pp.kleur.hex) || '#f4f0e4';
        var gaten = el.gatenVan(it);
        if (gaten && gaten.length) {
          binnen.appendChild(el.tekenGaten(it, gaten, randCm));
          binnen.appendChild(el.tekenGatKnoppen(it, gaten, randCm, ppc));
        }
      } else {
        binnen = document.createElement('div');
        binnen.className = 'gw__leegvlak';
      }
      d.appendChild(binnen);

      var weg = document.createElement('button');
      weg.type = 'button';
      // wit kruisje op een donker passe-partout, donker op een licht
      weg.className = 'gw__weg' + (rvs || isLicht(it.pp && it.pp.kleur && it.pp.kleur.hex)
        ? ' gw__weg--donker' : '');
      weg.title = el.t.verwijder;
      weg.setAttribute('aria-label', el.t.verwijder);
      // de handgetekende kruislijnen uit Hannahs eigen bestand
      weg.innerHTML = '<svg viewBox="8 9 28 28" fill="none" stroke="currentColor" ' +
        'stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M12.0003 11.0014C11.9956 10.9892 11.9909 10.977 15.4918 14.762C18.9928 18.5471 ' +
        '25.9996 26.1297 29.7041 30.1703C33.4086 34.2109 33.5984 34.4796 33.7288 34.6579C33.8591 ' +
        '34.8361 33.9242 34.9157 34 35"/>' +
        '<path d="M10.6255 33.4402C10.6275 33.4258 10.7086 33.2912 11.5275 32.417C12.2459 31.65 ' +
        '13.6618 30.3064 17.4911 27.0701C21.3204 23.8339 27.5412 18.7661 30.8098 16.092C34.0784 ' +
        '13.4179 34.2063 13.2911 34.3567 13.1354"/></svg>';
      // niet laten doorwerken naar de laag eronder, anders begint het slepen
      weg.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
      weg.addEventListener('click', function (e) {
        e.stopPropagation();
        el.verwijder(it.id);
      });
      d.appendChild(weg);

      if (rvs) {
        var draai = document.createElement('button');
        draai.type = 'button';
        draai.className = weg.className.replace('gw__weg', 'gw__weg gw__los');
        draai.title = el.t.draaien;
        draai.setAttribute('aria-label', el.t.draaien);
        draai.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" ' +
          'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M13.2 8.5A5.2 5.2 0 113 6"/><path d="M1.6 2.8L3 6l3.2-1.2"/></svg>';
        draai.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
        draai.addEventListener('click', function (e) {
          e.stopPropagation();
          el.draai(it.id);
        });
        d.appendChild(draai);
      }

      if (it.lijst && it.pp && !it.pp.inbegrepen) {
        var los = document.createElement('button');
        los.type = 'button';
        los.className = weg.className.replace('gw__weg', 'gw__weg gw__los');
        los.title = el.t.losmakenMuur;
        los.setAttribute('aria-label', el.t.losmakenMuur);
        // twee rechthoeken die uit elkaar schuiven
        los.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" ' +
          'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<rect x="1.8" y="1.8" width="7.4" height="9.4"/>' +
          '<path d="M11.5 5.2h2.7v9H7.3v-1.4"/></svg>';
        los.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
        los.addEventListener('click', function (e) {
          e.stopPropagation();
          el.haalUitElkaar(it.id);
        });
        d.appendChild(los);
      }

      el.eLaag.appendChild(d);

      if (rvs) {
        staal(it.lijst.foto, it.lijst.handle, it.liggend).then(function (url) {
          if (!url || !binnen.isConnected) return;
          binnen.style.backgroundImage = 'url(' + url + ')';
        });
      } else if (it.lijst && it.lijst.foto) {
        profiel(it.lijst.foto, afwerkingVan(it.lijst)).then(function (p) {
          if (!p || !d.isConnected) return;
          d.style.borderImage = 'url(' + p.url + ') ' + p.slice + ' stretch';
          d.style.borderColor = 'transparent';
        });
      }
      if (it.pp && it.pp.kleur && it.pp.kleur.staal) {
        karton(it.pp.kleur.staal, ppc).then(function (k) {
          if (!k || !binnen.isConnected) return;
          binnen.style.background = k.kleur;
          var tex = document.createElement('div');
          tex.className = 'gw__tex';
          tex.style.backgroundImage = 'url(' + k.tex + ')';
          var t = ((k.cm || STAAL_CM) * ppc).toFixed(1) + 'px';
          tex.style.backgroundSize = t + ' ' + t;
          binnen.insertBefore(tex, binnen.firstChild);
        });
      }
    });

    this.itemSlepen();
  };

  /* ---------- slepen en in elkaar schuiven ---------- */

  // Past dit stuk in dat andere? Alleen een losse lijst en een los
  // passe-partout van dezelfde buitenmaat horen bij elkaar.
  function passenSamen(a, b) {
    if (!a || !b || a.id === b.id) return false;
    if (isRvs(a) || isRvs(b)) return false;
    var eenVanElk = (a.lijst && !a.pp && b.pp && !b.lijst) || (a.pp && !a.lijst && b.lijst && !b.pp);
    if (!eenVanElk) return false;
    return Math.abs(a.w - b.w) < 0.15 && Math.abs(a.h - b.h) < 0.15;
  }

  GalleryWall.prototype.itemOnder = function (it, x, y) {
    var gevonden = null;
    this.state.items.forEach(function (o) {
      if (o.id === it.id) return;
      var mx = x + it.w / 2, my = y + it.h / 2;
      if (mx >= o.x && mx <= o.x + o.w && my >= o.y && my <= o.y + o.h) gevonden = o;
    });
    return gevonden;
  };

  GalleryWall.prototype.itemSlepen = function () {
    if (this._sleepAan) return;
    this._sleepAan = true;
    var el = this, sleep = null;

    this.eLaag.addEventListener('pointerdown', function (e) {
      var d = e.target.closest('.gw__item');
      if (!d) return;
      // (klikken naast een item wordt hieronder op de pagina afgevangen)
      var it = el.state.items.filter(function (x) { return x.id === d.dataset.id; })[0];
      if (!it) return;
      sleep = { it: it, d: d, ppc: el.pxPerCm(), sx: e.clientX, sy: e.clientY, ox: it.x, oy: it.y,
                voor: JSON.stringify(el.state.items) };
      // de knoppen in de uitsnedes kijken hiernaar: pas reageren als het stuk
      // al gekozen was, en niet als de klik eigenlijk een sleep was
      el._wasGekozen = el.state.gekozen === it.id;
      el._netGesleept = false;
      el.state.gekozen = it.id;
      el.eLaag.querySelectorAll('.gw__item').forEach(function (n) {
        n.classList.toggle('is-gekozen', n === d);
      });
      d.setPointerCapture(e.pointerId);
      el.tekenLijst();
      e.preventDefault();
    });

    this.eLaag.addEventListener('pointermove', function (e) {
      if (!sleep) return;
      if (Math.abs(e.clientX - sleep.sx) + Math.abs(e.clientY - sleep.sy) > 3) {
        el._netGesleept = true;
      }
      var b = el.eCanvas.getBoundingClientRect();
      var muurH = b.height / sleep.ppc;
      var nx = sleep.ox + (e.clientX - sleep.sx) / sleep.ppc;
      var ny = sleep.oy + (e.clientY - sleep.sy) / sleep.ppc;
      nx = Math.max(0, Math.min(el.muurCm() - sleep.it.w, nx));
      ny = Math.max(0, Math.min(muurH - sleep.it.h, ny));

      // uitlijnen op wat er al hangt
      el.state.items.forEach(function (o) {
        if (o.id === sleep.it.id) return;
        [o.x, o.x + o.w - sleep.it.w, o.x + o.w / 2 - sleep.it.w / 2].forEach(function (p) {
          if (Math.abs(nx - p) < SNAP_CM) nx = p;
        });
        [o.y, o.y + o.h - sleep.it.h, o.y + o.h / 2 - sleep.it.h / 2].forEach(function (p) {
          if (Math.abs(ny - p) < SNAP_CM) ny = p;
        });
      });

      sleep.it.x = nx;
      sleep.it.y = ny;
      sleep.d.style.left = (nx * sleep.ppc) + 'px';
      sleep.d.style.top = (ny * sleep.ppc) + 'px';

      // laten zien waar het in zou passen
      var onder = el.itemOnder(sleep.it, nx, ny);
      el.eLaag.querySelectorAll('.gw__item').forEach(function (n) {
        n.classList.toggle('is-doel', !!onder && n.dataset.id === onder.id &&
                                      passenSamen(sleep.it, onder));
      });
    });

    // Klikken naast de items laat de selectie los, waar dan ook op de pagina.
    // De regels in de bestellijst horen erbij: die selecteren juist.
    document.addEventListener('pointerdown', function (e) {
      if (!el.state.gekozen) return;
      if (e.target.closest('.gw__item') || e.target.closest('.gw__regel')) return;
      el.state.gekozen = null;
      el.tekenItems();
      el.tekenLijst();
    });

    function stop(e) {
      if (!sleep) return;
      var it = sleep.it;
      var onder = el.itemOnder(it, it.x, it.y);
      // Alleen een echte verplaatsing telt als stap; een klik om te kiezen niet.
      if (Math.abs(it.x - sleep.ox) > 0.01 || Math.abs(it.y - sleep.oy) > 0.01) {
        el.onthoud(sleep.voor);
      }
      sleep = null;

      // Een klik zonder slepen, op een stuk dat al gekozen was, op een van de
      // uitsnedes: dan wil iemand daar zijn eigen foto in zetten. Het gaat via
      // het loslaten en niet via de knop zelf, omdat het item de pointer
      // vasthoudt zolang je sleept — de klik komt daardoor bij het item uit.
      if (e && e.type === 'pointerup' && !el._netGesleept && el._wasGekozen) {
        var onderPunt = document.elementFromPoint(e.clientX, e.clientY);
        var knop = onderPunt && onderPunt.closest && onderPunt.closest('.gw__gatknop');
        if (knop) {
          el.kiesGatFoto(it, parseInt(knop.dataset.gat, 10) || 0);
          return;
        }
      }
      if (onder) {
        if (passenSamen(it, onder)) el.voegSamen(it, onder);
        // in een RVS-lijst past geen passe-partout
        else if (it.pp && !it.lijst && isRvs(onder)) el.melding(el.t.paster);
        else if (!isRvs(it) && !isRvs(onder) &&
                 ((it.lijst && !it.pp && onder.lijst) || (it.pp && !it.lijst && onder.pp))) {
          // twee dezelfde soorten of maten die niet kloppen: laten liggen
          if (Math.abs(it.w - onder.w) >= 0.15 || Math.abs(it.h - onder.h) >= 0.15) {
            el.melding(el.t.paster);
          }
        }
      }
      el.bewaar();
      el.tekenLijst();
    }
    this.eLaag.addEventListener('pointerup', stop);
    this.eLaag.addEventListener('pointercancel', stop);
  };

  GalleryWall.prototype.voegSamen = function (a, b) {
    var lijstItem = a.lijst ? a : b;
    var ppItem = a.pp ? a : b;
    lijstItem.pp = ppItem.pp;
    lijstItem.x = a.lijst ? a.x : b.x;
    lijstItem.y = a.lijst ? a.y : b.y;
    this.state.items = this.state.items.filter(function (x) { return x.id !== ppItem.id; });
    this.state.gekozen = lijstItem.id;
    this.melding(this.t.samen);
    this.bewaar();
    this.tekenItems();
  };

  GalleryWall.prototype.haalUitElkaar = function (id) {
    var it = this.state.items.filter(function (x) { return x.id === id; })[0];
    if (!it || !it.lijst || !it.pp || it.pp.inbegrepen) return;
    this.onthoud();
    // Rechts ernaast als daar plek is, anders links ervan.
    var muur = this.muurCm();
    var x = it.x + it.w + 2;
    if (x + it.w > muur) x = it.x - it.w - 2 >= 0 ? it.x - it.w - 2 : Math.max(0, muur - it.w);
    var los = {
      id: 'i' + Date.now() + Math.round(Math.random() * 999),
      w: it.w, h: it.h,
      x: x,
      y: it.y,
      lijst: null, pp: it.pp
    };
    it.pp = null;
    this.state.items.push(los);
    this.state.gekozen = los.id;
    this.bewaar();
    this.tekenItems();
    this.tekenLijst();
  };


  /* ---------- wat het kost ---------- */

  GalleryWall.prototype.regelsVan = function (it) {
    var regels = [];
    var inbegrepen = !!(it.pp && it.pp.inbegrepen);
    if (it.lijst) {
      // Bij de kioskfoto-lijst zit het karton erbij; dat staat dan in deze
      // regel, en er komt geen aparte regel voor het passe-partout.
      var detail = inbegrepen
        ? [it.lijst.formaat, it.lijst.kleur, it.pp.kleur && it.pp.kleur.naam, it.pp.binnenformaat]
        : [it.lijst.formaat, it.lijst.binnenformaat];
      regels.push({
        soort: 'lijst', naam: it.lijst.naam, detail: detail.filter(Boolean).join(' · '),
        variant: it.lijst.variant, prijs: it.lijst.prijs,
        beschikbaar: it.lijst.beschikbaar, ontbreekt: !it.lijst.variant
      });
    }
    if (it.pp && !inbegrepen) {
      regels.push({
        soort: 'passe-partout', naam: it.pp.naam,
        detail: [it.pp.formaat, it.pp.kleur && it.pp.kleur.naam, it.pp.binnenformaat]
          .filter(Boolean).join(' · '),
        variant: it.pp.variant, prijs: it.pp.prijs,
        beschikbaar: it.pp.beschikbaar, ontbreekt: !it.pp.variant
      });
    }
    return regels;
  };

  GalleryWall.prototype.miniTekening = function (it) {
    var U = window.GalleryWallUitsneden, V = window.GalleryWallVormen;
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 ' + it.w + ' ' + it.h);
    var achter = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    achter.setAttribute('width', it.w);
    achter.setAttribute('height', it.h);
    achter.setAttribute('class', 'gw__mini-karton');
    if (it.pp && it.pp.kleur && it.pp.kleur.hex) achter.setAttribute('fill', it.pp.kleur.hex);
    if (isRvs(it)) achter.setAttribute('fill', '#c9c9c5');
    svg.appendChild(achter);
    (this.gatenVan(it) || []).forEach(function (g) {
      var n;
      if (g.vorm === 'rechthoek' || !V) {
        n = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        n.setAttribute('x', g.x); n.setAttribute('y', g.y);
        n.setAttribute('width', g.w); n.setAttribute('height', g.h);
      } else {
        n = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        n.setAttribute('d', V.pad(g.vorm, g.w, g.h));
        n.setAttribute('transform', 'translate(' + g.x + ' ' + g.y + ')');
      }
      if (g.hoek) {
        n.setAttribute('transform',
          'rotate(' + g.hoek + ' ' + (g.x + g.w / 2) + ' ' + (g.y + g.h / 2) + ') ' +
          (n.getAttribute('transform') || ''));
      }
      n.setAttribute('class', 'gw__mini-gat');
      svg.appendChild(n);
    });
    return svg;
  };

  GalleryWall.prototype.tekenLijst = function () {
    var el = this;
    if (!this.eLijst) return;
    var rijen = this.eLijst.querySelector('[data-gw-rows]');
    var leeg = this.eLijst.querySelector('[data-gw-empty]');
    if (!rijen) return;
    rijen.innerHTML = '';
    var totaal = 0, compleet = true;

    this.state.items.forEach(function (it) {
      var li = document.createElement('li');
      li.className = 'gw__regel' + (el.state.gekozen === it.id ? ' is-gekozen' : '');

      var mini = document.createElement('div');
      mini.className = 'gw__regel-mini';
      if (it.pp || isRvs(it)) mini.appendChild(el.miniTekening(it));
      else {
        var vlak = document.createElement('div');
        vlak.className = 'gw__regel-vlak';
        vlak.style.aspectRatio = it.w + ' / ' + it.h;
        mini.appendChild(vlak);
      }
      li.appendChild(mini);

      var tekst = document.createElement('div');
      tekst.className = 'gw__regel-tekst';
      el.regelsVan(it).forEach(function (r) {
        if (r.prijs) totaal += r.prijs;
        if (!r.variant || !r.beschikbaar) compleet = false;
        var pEl = document.createElement('p');
        pEl.className = 'gw__regel-deel' + (r.variant && r.beschikbaar ? '' : ' is-probleem');
        var prijs = r.ontbreekt ? el.t.geenVariant
                  : (!r.beschikbaar ? el.t.uitverkocht : euro(r.prijs));
        pEl.innerHTML = '<span class="gw__regel-naam"></span>' +
                        '<span class="gw__regel-detail"></span>' +
                        '<span class="gw__regel-prijs"></span>';
        pEl.children[0].textContent = r.naam;
        pEl.children[1].textContent = r.detail;
        pEl.children[2].textContent = prijs;
        tekst.appendChild(pEl);
      });
      if ((!it.pp || !it.lijst) && !isRvs(it)) {
        var los = document.createElement('p');
        los.className = 'gw__regel-deel';
        los.innerHTML = '<span class="gw__regel-detail"></span>';
        los.children[0].textContent = it.lijst ? el.t.zonderPp : el.t.zonderLijst;
        tekst.appendChild(los);
      }
      li.appendChild(tekst);

      var knoppen = document.createElement('div');
      knoppen.className = 'gw__regel-knoppen';
      if (it.lijst && it.pp && !it.pp.inbegrepen) {
        knoppen.appendChild(el.icoonKnop(el.t.losmaken,
          '<path d="M6 2v5M10 2v5M3.5 7h9l-.8 6.5a1 1 0 01-1 .9H5.3a1 1 0 01-1-.9z" />',
          function () { el.haalUitElkaar(it.id); }));
      }
      if (heeftGatFotos(it)) {
        knoppen.appendChild(el.icoonKnop(el.t.fotoWeg,
          '<path d="M2.5 5.5h3l1-1.5h3l1 1.5h3v8h-11z"/><path d="M5 12.5l6-6"/>',
          function () { el.wisGatFotos(it.id); }));
      }
      knoppen.appendChild(el.icoonKnop(el.t.dupliceer,
        '<rect x="5.5" y="5.5" width="9" height="9" rx="1.5"/><path d="M10.5 3.5V2.5a1 1 0 00-1-1h-7a1 1 0 00-1 1v7a1 1 0 001 1h1"/>',
        function () { el.dupliceer(it.id); }));
      knoppen.appendChild(el.icoonKnop(el.t.verwijder,
        '<path d="M3 4.5h10M6.5 4.5V3h3v1.5M4.5 4.5l.6 9a1 1 0 001 .9h3.8a1 1 0 001-.9l.6-9"/>',
        function () { el.verwijder(it.id); }));
      li.appendChild(knoppen);

      li.addEventListener('click', function (e) {
        if (e.target.closest('button')) return;
        el.state.gekozen = it.id;
        el.tekenItems();
        el.tekenLijst();
      });
      rijen.appendChild(li);
    });

    var aantal = this.state.items.length;
    if (leeg) leeg.hidden = aantal > 0;
    var tot = this.eLijst.querySelector('[data-gw-total]');
    if (tot) tot.textContent = euro(totaal);
    var knop = this.eLijst.querySelector('[data-gw-cart]');
    if (knop) knop.disabled = !aantal || !compleet;
    var telling = this.eLijst.querySelector('[data-gw-count]');
    if (telling) {
      telling.textContent = aantal === 1 ? this.t.eenDing : this.t.aantalDing.replace('{n}', aantal);
    }
  };

  GalleryWall.prototype.icoonKnop = function (titel, pad, fn) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'gw__icoon';
    b.title = titel;
    b.setAttribute('aria-label', titel);
    b.innerHTML = '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" ' +
                  'stroke="currentColor" stroke-width="1.3">' + pad + '</svg>';
    b.addEventListener('click', fn);
    return b;
  };

  GalleryWall.prototype.verwijder = function (id) {
    this.onthoud();
    this.state.items = this.state.items.filter(function (x) { return x.id !== id; });
    if (this.state.gekozen === id) this.state.gekozen = null;
    this.bewaar();
    this.tekenItems();
    this.tekenLijst();
  };

  GalleryWall.prototype.dupliceer = function (id) {
    var bron = this.state.items.filter(function (x) { return x.id === id; })[0];
    if (!bron) return;
    this.onthoud();
    var kopie = JSON.parse(JSON.stringify(bron));
    kopie.id = 'i' + Date.now() + Math.round(Math.random() * 999);
    kopie.x = Math.min(bron.x + bron.w + 2, this.muurCm() - bron.w);
    this.state.items.push(kopie);
    this.state.gekozen = kopie.id;
    this.bewaar();
    this.tekenItems();
    this.tekenLijst();
  };

  GalleryWall.prototype.naarWinkelwagen = function () {
    var el = this;
    var knop = this.eLijst.querySelector('[data-gw-cart]');
    var melding = this.eLijst.querySelector('[data-gw-cart-msg]');
    var items = [];
    this.state.items.forEach(function (it, i) {
      el.regelsVan(it).forEach(function (r) {
        if (!r.variant) return;
        var eigenschappen = {};
        eigenschappen[el.t.cartWand] = el.t.cartPlek.replace('{n}', i + 1);
        // Zelfde namen als op de productpagina van de kioskfoto-lijst, daar
        // kijken de orderbevestiging en het inpakken naar.
        if (r.soort === 'lijst' && it.pp && it.pp.inbegrepen) {
          if (it.pp.kleur) eigenschappen['Kleur passe-partout'] = it.pp.kleur.naam;
          eigenschappen['Eigen maat'] = it.pp.binnenformaat;
        }
        if (r.soort === 'passe-partout' && it.pp && it.pp.binnenformaat) {
          eigenschappen[el.t.cartUitsnede] = it.pp.binnenformaat;
        }
        items.push({ id: r.variant, quantity: 1, properties: eigenschappen });
      });
    });
    if (!items.length) return;

    if (knop) knop.disabled = true;
    if (melding) { melding.hidden = true; melding.textContent = ''; }

    fetch(cartPad('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || res.status); });
      return res.json();
    }).then(function () {
      if (melding) { melding.hidden = false; melding.className = 'gw__cart-ok'; melding.textContent = el.t.cartGelukt; }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(function () { window.location.href = cartPad('/cart'); }, 900);
    }).catch(function (e) {
      if (melding) {
        melding.hidden = false;
        melding.className = 'gw__fout';
        melding.textContent = el.t.cartFout + ' (' + e.message + ')';
      }
      if (knop) knop.disabled = false;
    });
  };

  /* ---------- stap terug ---------- */

  // Legt de stand van de muur vast vóór een wijziging. Bij slepen is die stand
  // al bij het vastpakken genomen en komt hij hier als tekst binnen.
  GalleryWall.prototype.onthoud = function (stand) {
    this.geschiedenis.push(stand || JSON.stringify(this.state.items));
    if (this.geschiedenis.length > MAX_STAPPEN) this.geschiedenis.shift();
    this.tekenTerugStap();
  };

  GalleryWall.prototype.stapTerug = function () {
    var stand = this.geschiedenis.pop();
    if (!stand) return;
    var el = this;
    this.state.items = JSON.parse(stand);
    if (!this.state.items.some(function (x) { return x.id === el.state.gekozen; })) {
      this.state.gekozen = null;
    }
    this.bewaar();
    this.tekenItems();
    this.tekenLijst();
    this.tekenTerugStap();
  };

  GalleryWall.prototype.wisGeschiedenis = function () {
    this.geschiedenis = [];
    this.tekenTerugStap();
  };

  GalleryWall.prototype.tekenTerugStap = function () {
    if (this.eTerugStap) this.eTerugStap.hidden = !this.geschiedenis.length;
  };

  /* ---------- opslag ---------- */

  GalleryWall.prototype.bewaar = function () {
    try {
      localStorage.setItem(OPSLAG, JSON.stringify(this.state));
      return;
    } catch (e) { /* hieronder nog een poging */ }
    // Eigen foto's in de uitsnedes zijn zo het grootst. Past het niet meer,
    // dan bewaren we de wand zonder die foto's: beter dan niets bewaren.
    try {
      var kaal = JSON.parse(JSON.stringify(this.state));
      kaal.items.forEach(function (it) {
        if (it.pp) delete it.pp.fotos;
        if (it.lijst) delete it.lijst.fotos;
      });
      localStorage.setItem(OPSLAG, JSON.stringify(kaal));
    } catch (e) { /* vol of geweigerd: dan bewaren we niets */ }
  };

  GalleryWall.prototype.herstel = function () {
    var ruw;
    try { ruw = localStorage.getItem(OPSLAG); } catch (e) { return; }
    if (!ruw) return;
    var s;
    try { s = JSON.parse(ruw); } catch (e) { return; }
    if (!s || !s.foto) return;
    var el = this;
    this.state = s;
    this.eFoto.src = s.foto;
    if (s.fotoCm) this.toonIjken(false);
    else this.startIjken();
    this.eFoto.addEventListener('load', function () { el.teken(); el.tekenLijst(); }, { once: true });
    setTimeout(function () { el.teken(); el.tekenLijst(); }, 60);
  };

  if (!customElements.get('gallery-wall-app')) {
    customElements.define('gallery-wall-app', GalleryWall);
  }

})();
